import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { HttpResponse, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import * as L from 'leaflet';
import * as R from 'leaflet-responsive-popup';
import 'leaflet.markercluster';
import 'leaflet-rotatedmarker';

import { AuthHttpService } from "../../services/auth-http.service";
import { CreateDialogComponent } from "../../shared/dialogs/create-dialog/create-dialog.component";
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { HelpDialogComponent } from "../../shared/dialogs/help-dialog/help-dialog.component";
import { trigger, state, animate, transition, style } from '@angular/animations';
import { Globals } from '../../globals';
//translate
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, Subscription } from 'rxjs';
import { AnalisisService } from '../../services/analisis.service';
import { SensorsService } from '../../services/sensors.service';
import { SelectService } from "../../services/select.service";
import { NgModel } from "@angular/forms";
import { SensorService } from "../../services/sensor.service";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import * as d3 from 'd3';
dayjs.extend(customParseFormat);

@Component({
    selector: 'app-main-new',
    templateUrl: './main-new.component.html',
    styleUrls: ['./main-new.component.scss'],
    animations: [
        trigger('filter_show', [
            state('true', style({
                height: "430px",
                overflow: 'hidden',
            })),
            state('false', style({
                height: "88px",
                overflow: 'hidden',
            })),
            transition('* => *', animate('.3s'))
        ]),
        trigger('filter_inc_show', [
            state('true', style({
                height: "520px"
            })),
            state('false', style({
                height: "88px"
            })),
            transition('* => *', animate('.3s'))
        ]),
        trigger('last_show', [
            state('true', style({
                minHeight: "256px",
                width: "230px"
            })),
            state('false', style({
                minHeight: "40px",
                width: "40px"
            })),
            transition('* => *', animate('.3s'))
        ]),
        trigger('filters_show', [
            state('true', style({
                minHeight: "calc(100vh - 100px)",

            })),
            state('false', style({
                height: "132px",
                minHeight: 0
            })),
            transition('* => *', animate('.3s'))
        ])
    ]
})
export class MainNewComponent implements OnInit, OnDestroy{

    mytime: Date = new Date();
    currentYear: any = this.mytime.getUTCFullYear();
    currentDate: any = this.mytime.getUTCDate() + 1; //для показа включая сегодняшнюю дату
    currentMonth: any = this.mytime.getUTCMonth() + 1; //months from 1-12
    sensors:Array<any>;
    general_sensors:Array<any>;
    searchDate:any;
    map:any;
    status:string = '';
    code:any = '';
    location:string;

    sensor = [];

    results:Array<any> = [];
    markersList:any = null;
    codeResults:any = {'': []};
    sto:boolean = false;
    noaccess = false;
    userdata:any;
    loaded = false;
    warning = false;

    location_lang:string;
    coordinates_lang:string;
    activation_lang:string;
    no_sensors_lang:string;
    add_sensors_to_project:string;


    no_project: any = {'text' : ''};
    no_permission: any = {'text' : ''};
    text_no_access: any = {'text' : ''};
    error_data:string;

    //фикс карты
    http_sensors:any;
    http_sensors_serv:any;
    http_user:any;

    //проверка на статус
    http_sensors_check:any;
    sensors_check = [];
    check_status:any = '';
    status_change:any = '';
    pvrList = [];

    //проверка событий
    http_events_check:any;
    events_check = [];
    inc_last = [];
    inc_last_name:string;
    inc_last_class:string;
    blink_date = false;
    under_filters = false;

    isDataAvailable = false;

    currentZoom = 0;
    params_number = 0;
    params_number_inc = 0;
    filter_show = false;
    filter_inc_show = false;
    filter_both_show = false;
    filter_both_show_inc = false;
    dir_from = true;
    dir_to = true;

    //incendents
    incTypeJson = [];
    incs: any;

    // конфигурация
    cl_co = 7;
    cl_min = 6;
    cl_max = 20;
    cl_min_w = 52;
    //let cl_max_w = 120;
    inc_project = [];
    inc_latitude:any;
    inc_longitude:any;
    incs_test_clust:any;
    def_period:any;

    //incidents language
    incidents_critical_lang:any;
    incidents_warning_lang:any;
    incidents_info_lang:any;
    sensor_name_lang:string;
    period_lang:string;
    incidents_lang:string;
    incidents_length_lang: string;
    incidents_speed_lang: string;
    incidents_lane_lang: string;
    incidents_not_specified_lang: string;
    incidents_kmh_lang: string;
    incidents_m_lang: string;
    dayLabels:any;
    monthLabels:any;
    begin_lang: string;
    end_lang: string;
    check_event_types_lang: string;
    no_events_lang: string;
    current_status_lang: string;
    //deleted_at_lang: string;

    //incidents filter
    inc_def_number = '10'; // кол-во инцидентов по умолчанию
    filteredTypesCheckDef = ["0","1","2"]; // типы, отмеченные по умолчанию
    numberEventsList = ['10','100','500','1000']; // кол-во для выбора в селекте по умолчанию
    numberEvents:any;
    eventsShow = true;
    inc_num_sel_show = true;
    filterIncDisabled = false;
    inc_subtypes = true;
    incTypeList = [];
    filteredTypes = [];
    filteredTypesCheck = [];
    hideme = {};
    reload_checked = false;
    reset_action = false;
    show_time = false;
    changeNum = false;
    notypes = false;
    type_loading = false;
    from_filter = false;
    count_project_sensors = 0;
    reset_inc = false;
    incs_layer = [];

    //направление датчика
    sensor_rotation = 0;
    dark_map = false;

    //для отписки от событий
    changeProjCancel:any;
    changeLangCancel:any;

    // иконки маркеров датчиков
    //active green
    activeIcon = L.divIcon({
        className: 'marker-active',
        iconAnchor: [15,30]
    });
    activeIconDir = L.divIcon({
        className: 'marker-active marker-dir',
        iconAnchor: [15,30]
    });
    selectedIconActive = L.divIcon({
        className: 'marker-selected-active',
        iconAnchor: [15,30]
    });
    selectedIconActiveDir = L.divIcon({
        className: 'marker-selected-active marker-dir',
        iconAnchor: [15,30]
    });
    selectedIconActiveSmall = L.divIcon({
        className: 'marker-selected-active marker-small',
        iconAnchor: [10,20]
    });
    selectedIconActiveSmallDir = L.divIcon({
        className: 'marker-selected-active marker-small marker-dir',
        iconAnchor: [10,20]
    });
    activeIconSmall = L.divIcon({
        className: 'marker-active marker-small',
        iconAnchor: [10,20]
    });
    activeIconSmallDir = L.divIcon({
        className: 'marker-active marker-small marker-dir',
        iconAnchor: [10,20]
    });

    //disconnected red
    inactiveIcon = L.divIcon({
        className: 'marker-inactive',
        iconAnchor: [15,30]
    });
    inactiveIconDir = L.divIcon({
        className: 'marker-inactive marker-dir',
        iconAnchor: [15,30]
    });
    selectedIconInactive = L.divIcon({
        className: 'marker-selected-inactive',
        iconAnchor: [15,30]
    });
    selectedIconInactiveDir = L.divIcon({
        className: 'marker-selected-inactive marker-dir',
        iconAnchor: [15,30]
    });
    inactiveIconSmall = L.divIcon({
        className: 'marker-inactive marker-small',
        iconAnchor: [10,20]
    });
    inactiveIconSmallDir = L.divIcon({
        className: 'marker-inactive marker-small marker-dir',
        iconAnchor: [10,20]
    });
    selectedIconInactiveSmall = L.divIcon({
        className: 'marker-selected-inactive marker-small',
        iconAnchor: [10,20]
    });
    selectedIconInactiveSmallDir = L.divIcon({
        className: 'marker-selected-inactive marker-small marker-dir',
        iconAnchor: [10,20]
    });

    //idle yellow
    idleIcon = L.divIcon({
        className: 'marker-error',
        iconAnchor: [15,30]
    });
    idleIconDir = L.divIcon({
        className: 'marker-error marker-dir',
        iconAnchor: [15,30]
    });
    selectedIconIdle = L.divIcon({
        className: 'marker-selected-error',
        iconAnchor: [15,30]
    });
    selectedIconIdleDir = L.divIcon({
        className: 'marker-selected-error marker-dir',
        iconAnchor: [15,30]
    });
    idleIconSmall = L.divIcon({
        className: 'marker-error marker-small',
        iconAnchor: [10,20]
    });
    idleIconSmallDir = L.divIcon({
        className: 'marker-error marker-small marker-dir',
        iconAnchor: [10,20]
    });
    selectedIconIdleSmall = L.divIcon({
        className: 'marker-selected-error marker-small',
        iconAnchor: [10,20]
    });
    selectedIconIdleSmallDir = L.divIcon({
        className: 'marker-selected-error marker-small marker-dir',
        iconAnchor: [10,20]
    });

    //deleted grey
    deletedIcon = L.divIcon({
        className: 'marker-deleted',
        iconAnchor: [15,30]
    });
    deletedIconDir = L.divIcon({
        className: 'marker-deleted marker-dir',
        iconAnchor: [15,30]
    });
    selectedIconDeleted = L.divIcon({
        className: 'marker-selected-deleted',
        iconAnchor: [15,30]
    });
    selectedIconDeletedDir = L.divIcon({
        className: 'marker-selected-deleted marker-dir',
        iconAnchor: [15,30]
    });
    deletedIconSmall = L.divIcon({
        className: 'marker-deleted marker-small',
        iconAnchor: [10,20]
    });
    deletedIconSmallDir = L.divIcon({
        className: 'marker-deleted marker-small marker-dir',
        iconAnchor: [10,20]
    });
    selectedIconDeletedSmall = L.divIcon({
        className: 'marker-selected-deleted marker-small',
        iconAnchor: [10,20]
    });
    selectedIconDeletedSmallDir = L.divIcon({
        className: 'marker-selected-deleted marker-small marker-dir',
        iconAnchor: [10,20]
    });

    //in service blue
    inServiceIcon = L.divIcon({
      className: 'marker-in-service',
      iconAnchor: [15,30]
    });
    inServiceIconDir = L.divIcon({
      className: 'marker-in-service marker-dir',
      iconAnchor: [15,30]
    });
    selectedIconInService = L.divIcon({
      className: 'marker-selected-in-service',
      iconAnchor: [15,30]
    });
    selectedIconInServiceDir = L.divIcon({
    className: 'marker-selected-in-service marker-dir',
    iconAnchor: [15,30]
  });
    inServiceIconSmall = L.divIcon({
      className: 'marker-in-service marker-small',
      iconAnchor: [10,20]
    });
    inServiceIconSmallDir = L.divIcon({
      className: 'marker-in-service marker-small marker-dir',
      iconAnchor: [10,20]
    });
    selectedIconInServiceSmall = L.divIcon({
      className: 'marker-selected-in-service marker-small',
      iconAnchor: [10,20]
    });
    selectedIconInServiceSmallDir = L.divIcon({
    className: 'marker-selected-in-service marker-small marker-dir',
    iconAnchor: [10,20]
  });

    //для отключения setInterval
    interval : any;
    clear_interval : any;
    refresh_interval : any;

    //временные переменные для отображение событий
    tmp_inc_coord: any;
    tmp_az: any;
    tmp_latlng1: any;
    tmp_latlng2: any;
    tmp_bearing: any;
    tmp_point_x: any;
    tmp_point_y: any;

    //*** new filter ***
    sensorList = [];
    sensorProjectList = [];
    sensorProjectListDef = [];
    tmp_sensors = [];
    sensor_select = [];
    selected_date: string;
    selected_name: any;
    selected_dir: any;
    selected_st_name: any;
    selected_st_status: any;
    selected_status: any;
    statusList = [];
    status_select = [];
    dirList = [];
    dir_select = [];
    statusListV = [];
    statusListV_check = [];
    show_found = true;
    fb_disabled = true;
    globSelected = [];
    fromfilter = false;
    sensorMap = [];
    //*** new filter ***

    http_incs: Subscription;
    show_last_event = false;
    inc_begin_date: Date;
    inc_end_date: Date;
    last_event_loading = false;

    //analisisService.dateBefore:any;
    //analisisService.dateAfter:any = new Date();
    load_date:any;
    min_date:any;
    inc_date_before_error = false;
    inc_date_after_error = false;
    set_scale = false;

    filterNumber = 0;
    filterDate = 0;
    filterTypes = 0;
    filterShowInc = 0;
    chFilterTypes = 0;
    colorTypesSel = [];

    last_show = false;
    filters_show = true;
    last_show_content = false;
    eventsFilterList = [];
    mf_events = true;
    mf_filter_events = false;
    mf_filter_sensors = false;
    eventsByFilter = false;
    ev_list_id:string;
    from_disabled_show_inc = true;
    filter_closed = false;
    mf_max_loading = false;
    mf_max_show = true;
    filter_inc_count = 0;
    wait_reset_inc = false;

    fit = [];
    touch_map = false;
    fitZoom = 0;

    laneDirList = [];
    map_controls:any;
    map_controls_padding_add = false;

    //projects-sensors-list
    projects_sensors_list = [];
    projects_sensors_list_done = false;

    p:number;

    //переменные для остлежтвания статусов запросов регулярной проверки
    //нужно, чтобы запросы выполнялись по очереди и ожидали завершения предыдущего
    check_status_done:boolean;
    check_last_event_done:boolean;

    //отметки о нажатии на  переход к событию, чтобы не перезагружать слой событий
    go_last_event_flag:boolean = false;
    go_list_event_flag:boolean = false;

    //для сохранения маркера события на которое перешли при автоматической перерисовке карты
    target_event_id:string | number = 0;

    //список даьчиков, у которых изменился статус со время 10-секундной проверки
    changed_sensors = [];
    need_reload:boolean = false;
    changed_sensors_block_open:boolean = false;

    //перевод zoom_in, zoom_out кнопок
    zoom_in_lang:string;
    zoom_out_lang:string;
    zoom_control:any;
    sensorStatus: any;
    sensorClass: any;
    senErrIcons: any = ['../assets/icons-map/warning-info.svg', '../assets/icons-map/warning.svg', '../assets/icons-map/warning-critical.svg']
    errorIcon: any;
    myPopup: any;
    warAnchor: number[][] = [];
    warType: string[] = [];
    serial_number: string;
    serial_number_translated: string;
    inc_last_data: any;
    new_event: string;
    sensor_object: any;
    sensorId: any;
    targetIp: any;
    sensor_ip_translated: any;
    sensor_id_translated: any;
    create_sensor_lang:string;

    constructor(
        public router:Router,
        private http:AuthHttpService,
        public dialog: MatDialog,
        public Globals:Globals,
        private translate: TranslateService,
        private analisisService: AnalisisService,
        private sensorsService : SensorsService,
        private  selectService: SelectService,
        public sensorService: SensorService
    ) {

        this.Globals.checkRoute();

        //this.onLangChanged();
        this.loadTypes(); //загружаем типы событий
        this.changeProjCancel = this.Globals.chProj.subscribe(this.changeProj.bind(this));
        this.load_date = this.analisisService.dateAfter;
    }

    //отслеживаем изменяемую в инпуте дэйтпикера дату (keyup) и ставим красный бордер, если дата некорректная
    catchInputDate(type_date_arr: any) {
        this.analisisService.setDateBorders(type_date_arr);
    }

    openGhangedSensors(){
        this.changed_sensors_block_open = !this.changed_sensors_block_open;
    }

    goToSensor(sensor: any){
        let latlng = [sensor.configuration.gps_latitude, sensor.configuration.gps_longitude];
        this.map.setView(latlng, 18);
    }

    checkStatus(){
        //каждые 10 сек получаем новый список датчиков и сверяем статус reading и connected,
        // + сверяем id у последнего события, если не совпадает с текущим, обновляем слой событий на карте

        //let statusParams:HttpParams = new HttpParams();
        let statusParams = {'sensor_id_list':''};
        let temp_changed_sensors = [];
        let ids: string[] = [];
        this.interval = setInterval(()=>{
            this.need_reload = false;

            if(!this.dark_map && !this.warning){
                if(Boolean(this.http_sensors_check)){
                    this.http_sensors_check.unsubscribe();
                    //console.log('unsubscribe done');
                }
                // проверка статуса
                //получаем статусы датчиков

                ids = [];
                temp_changed_sensors = [];
                this.sensorProjectList.forEach((sensor) => {
                    ids.push(sensor.sensor_id);
                });
                //statusParams = statusParams.set('sensor_id_list', JSON.stringify(ids));
                statusParams.sensor_id_list = JSON.stringify(ids);
                if(this.check_last_event_done){
                    this.statusListV_check = [];
                    this.check_status_done = false;
                    this.http.post('/api/sensor/status_v', statusParams).subscribe((res) => {
                        this.statusListV_check = res.body;
                        this.check_status_done = true;
                        this.check_status = new Date();
                        if(this.sensorProjectList.length > 0){
                            this.statusListV_check.forEach(ch=>{

                                let found_sensor =  this.sensorProjectList.find(sensor=>!sensor.del_from_project && ch.sensor_id == sensor.sensor_id && ch.current_status_code != sensor.status_v);
                                if(Boolean(found_sensor)){
                                    found_sensor.status_v =  ch.current_status_code;
                                    //found_sensor.status_v_list =  ch.current_status_list;
                                    found_sensor.status_v_list = this.sensorsService.translateStatus(ch.current_status_list);
                                    temp_changed_sensors.push(found_sensor);
                                }
                            });
                        }
                        let compareArr = () =>{
                            let result: any;
                            if(temp_changed_sensors.length){
                                result = temp_changed_sensors.filter(({ 'sensor_id': id1 }) => !this.changed_sensors.some(({ 'sensor_id': id2 }) => id2 === id1));
                            }else{
                                result = [];
                            }

                            return result;
                        }
                        //console.log(' compareArr', compareArr());
                        //проверяем, если changed_sensors пустой или отличаеся то меняем его на полученный
                        if((!this.changed_sensors.length || compareArr().length) && temp_changed_sensors.length){
                            this.changed_sensors = JSON.parse(JSON.stringify(temp_changed_sensors));
                            this.need_reload = true;
                            //console.log('changed_sensors',this.changed_sensors);
                        }else{
                            this.need_reload = false;
                        }


                        // if(!this.changed_sensors.length){
                        //     this.need_reload = false;
                        // }else{
                        //     this.need_reload = true;
                        //     this.show_changed_message = true;
                        // }
                        if(this.need_reload){
                            if(this.sensorProjectList.length > 0 && Boolean(this.map)){
                                //если применен фильтр статусов
                                if(this.status_select.length < 4 && this.fromfilter){
                                    this.chooseDirStatus(true);
                                    if(this.sensor_select.length == 0){
                                    this.defaultFilter();
                                    }
                                }else{
                                    this.markersIcons();
                                }
                            }
                            this.status_change = new Date();
                        }
                    });
                }

                // проверка событий
                if(this.check_status_done){
                  this.loadIncLast();
                }

            }
            //console.log('this.changed_sensors',this.changed_sensors);
            //console.log('temp_changed_sensors',temp_changed_sensors);
            //console.log('ids',ids);
        },10000);
    }

    ngOnInit() {
        this.isDataAvailable = false;
        this.reload_checked = true;
        if(!Boolean(this.Globals.user)){
            this.http_user = this.http.get('/api/user/data?_userMainPage').subscribe( (res:HttpResponse<any>) => {
                this.Globals.user = res.body;
                if(!Boolean(this.Globals.select_project)){
                    if(sessionStorage.project){
                        this.Globals.select_project = localStorage.getItem('project');
                    }
                    else if(this.Globals.user.projects.length){
                        this.Globals.select_project = this.Globals.user.projects[0].projects_id;
                    }else{
                        this.Globals.select_project = '';
                    }
                }
                this.ifRecieveUser();
            });
        }else{
            if(!Boolean(this.Globals.select_project)){
                if(sessionStorage.project){
                    this.Globals.select_project = localStorage.getItem('project');
                }
                else if(this.Globals.user.projects.length){
                    this.Globals.select_project = this.Globals.user.projects[0].projects_id;
                }else{
                    this.Globals.select_project = '';
                }

            }
        }
        this.analisisService.selectedSensors.subscribe(data => this.globSelected = data);
        this.numberEvents = this.inc_def_number;
    }

    ngAfterViewInit() {
        //timeout ставится, чтобы не возникала ошибка "Expression has changed after it was checked" https://blog.angular-university.io/angular-debugging/
        setTimeout(() => {
            this.changeLangCancel = this.Globals.langJS.subscribe(this.onLangChanged.bind(this));
            document.querySelector('body').classList.add('vt-bg');

            if(Boolean(this.Globals.user) && this.ifRecieveUser()){

                this.afterGet();
            }
            // проверяем статус и события каждые 10 сек
            this.checkStatus();
        });
    }

    // --- start --- добавили попап в правую кнопку для получения координат --- //
    right_click_popup = L.popup();
    right_click_latlng;
    right_click_popup_html;
    coordinates_copied_to_clipboard_lang;

    copyLatLang(){

        //копирование в буфер обмена
        this.Globals.clipboard.copy(this.right_click_latlng);

        this.dialog.open(CreateDialogComponent, < MatDialogConfig > {
            data: {
                text: this.coordinates_copied_to_clipboard_lang,
                reset_event: true,
                icon_class:"dialog-icon-success"
            }
        });
    }

    createSensorWithLatLang(){
        sessionStorage.setItem('latlng', this.right_click_latlng.replace(' ',''));
        this.router.navigateByUrl('/admin/admin-sensors/new/general')
    }
    // --- end --- добавили попап в правую кнопку для получения координат --- //

    loadMap(){
        //загружаем карту
        let self = this;
        if(!Boolean(this.map)){
          this.map = L.map('map', {
            zoomControl: true,
            maxZoom: 40
          }).setView([55.75578, 37.61786], 23)

          //добавили попап в правую кнопку для получения координат
          .on('contextmenu',(e) => {

              //---------- если у юзера есть привилегия на редактирование датчиков ------- //
              let priv = this.Globals.user.role.privileges.find(p=>p.privileges_id == '97dba9b4-4b97-f6aa-cfb8-f00665565e74');

              if(Boolean(priv) && priv.mode == 1){
                  this.right_click_latlng = e.latlng.lat.toFixed(5) + ', ' + e.latlng.lng.toFixed(5);
                  this.right_click_popup_html = `

                      <div class="right-click-popup">
                          <span class="right-click-popup-header"> ${this.right_click_latlng}</span>
                          <button id="r_create" class="filter-button">${this.create_sensor_lang}</button>
                      </div>
                  `
                  this.right_click_popup
                      .setLatLng(e.latlng)
                      .setContent(this.right_click_popup_html)
                      .addTo(this.map)
                      .on('blur', function () {
                          this.closePopup();
                      })

                  let el = d3.select('.right-click-popup-header');

                  el.on('click', () => {
                      self.copyLatLang();
                  });

                  let btn_el = d3.select('#r_create');

                  btn_el.on('click', () => {
                      self.createSensorWithLatLang();
                  });
              }
              //---------- если у юзера есть привилегия на редактирование датчиков ------- //
          });
          this.zoom_control = L.control.zoom({
              position:'bottomright',
              zoomInTitle:this.zoom_in_lang,
              zoomOutTitle:this.zoom_out_lang
          }).addTo(this.map);
          if(this.sensorProjectList.length){
              this.drawPoints(false);
          }

        }else{
          this.zoom_control.remove();
          this.zoom_control = L.control.zoom({
              position:'bottomright',
              zoomInTitle:this.zoom_in_lang,
              zoomOutTitle:this.zoom_out_lang
          }).addTo(this.map);

        }
    }
    moveMapControls(add: boolean){
        let controls = Array.from(document.getElementsByClassName("leaflet-right"));
        if(!add || (!this.filter_both_show_inc && !this.filter_both_show)){
            controls.map(element=>element.classList.remove('map-control-padding'));
            this.map_controls_padding_add = false;
        }else{
            controls.map(element=>element.classList.add('map-control-padding'));
            this.map_controls_padding_add = true;
        }
    }
    defaultMin(){
        this.Globals.createList = [];
        if(this.sensorProjectList.length>0){
            this.sensorProjectList.map(sp=>{
                let act_date = new Date(sp.create_ts.replace(' ', 'T').slice(0, 19));
                //формируем список дат создания датчиков проекта
                this.Globals.createList.push(act_date);
            });
        }

        //делаем сортировку дат в массиве по возрастанию
        let date_sort_asc = function (date1: number, date2: number) {
            if (date1 > date2) return 1;
            if (date1 < date2) return -1;
            return 0;
        };
        //получаем наименьшую дату создания датчика
        if(Boolean(this.Globals.createList)){
            this.Globals.createList.sort(date_sort_asc);
            if(Boolean(this.Globals.createList[0])){
                let minCreate = this.Globals.createList[0];
                if(Boolean(minCreate)){
                    this.Globals.minDate = {year: minCreate.getFullYear(), month: minCreate.getMonth()+1, day: minCreate.getDate()};
                    this.min_date = minCreate;
                    this.analisisService.dateBefore = minCreate;

                }
            }
        }
    }
    ifRecieveUser(){
        if(Boolean(this.Globals.user)){
            if(this.Globals.user.role.privileges.some((e: { privileges_id: string; }) => e.privileges_id === '69770f3c-3047-f1e7-3f65-87f4792fc013')){
                if(!Boolean(this.Globals.user.projects[0])){
                    this.warning = true;
                    this.noaccess = true;
                    this.text_no_access = this.no_project;
                    this.isDataAvailable = true;
                    return false;
                }

                //устанавливаем проект, выбранный или первый в списке проектов юзера
                let gsp = this.Globals.select_project;
                if(!Boolean(gsp)){
                    gsp = this.Globals.user.projects[0].projects_id;
                }

                if(this.sensorsService.getSensorsGlobalData().length){
                    this.sensorProjectList = this.sensorsService.getSensorsGlobalData();


                    this.afterGet();
                    // устанавливаем минимальную дату для фильтра событий
                    this.defaultMin();

                    return true;
                }else{

                    //из нового сервиса
                    this.dark_map = false;
                    let params = {
                        'main':'true',
                        'error_text': this.error_data,
                        'project_id': gsp
                    }
                    this.http_sensors = this.sensorsService.sensors(params).subscribe(res =>{
                        this.sensorProjectList = res;
                            if(this.sensorProjectList.length == 0){
                                this.filter_both_show = false;
                                this.noSensors();
                                return false;
                            }

                        this.sensorProjectListDef = JSON.parse(JSON.stringify(this.sensorProjectList));
                        this.afterGet();

                        // устанавливаем минимальную дату для фильтра событий
                        this.defaultMin();
                        return true;
                    });
                }

            }else{
               this.warning = true;
               this.text_no_access = this.no_permission;
               this.isDataAvailable = true;
            }
        }
    }
    afterGet(){
        this.isDataAvailable = false;
        this.dark_map = false;
        if(this.sensorProjectList.length > 0){
            if(Boolean(this.map)){
                //отправляем список датчиков для попапа карты
                this.analisisService.projectSensorsGlob = this.sensorProjectList;

                //создаем список для отметки датчиков на карте
                this.sensor = [];
                this.sensorProjectList.forEach(s=>{
                    this.sensor.push({name: s.name, sensor_id: s.sensor_id, create_ts: s.create_ts, selected: false});
                })

                //сверяем с глобальным списком отмеченных датчиков и отмечаем датчики из списка

                if(this.globSelected.length > 0){
                    this.sensor.forEach(s=>{
                        this.globSelected.forEach(gs=>{
                            if(Boolean(gs) && gs.sensor_id == s.sensor_id){
                                s.selected = true;
                            }
                        });
                    });
                }
                //отмечаем по умолчанию все датчики проекта в мультиселекте фильтра
                this.sensor_select = [];
                if(this.sensorProjectList.length > 0){
                    this.sensorProjectList.forEach(s=>{
                        this.sensor_select.push(s.sensor_id);
                    });
                    this.show_found = false;
                }
                this.show_found = false;
                this.sensor_select.length > 0 ? this.fb_disabled = false : this.fb_disabled = true;

                //скрываем фильтр датчиков если в проекте всего один датчик
                if(this.sensorProjectList.length == 1){
                    this.filter_both_show = false;
                    this.mf_filter_sensors = false;
                }

                // загрузка инцидентов и рисование карты
                this.drawPoints(true);
            }
        }
    }
    //*** new filter ***
    chooseSensor(){
        this.show_found = false;
        let selected_sensors_temp = [];
        this.sensorProjectList.map(sp =>{
            this.sensor_select.map(ss=>{
                if(sp.sensor_id == ss){
                    selected_sensors_temp.push(sp);
                    if(selected_sensors_temp.length == 1){
                        // для вывода в шаблоне селекта получаем имя и дату добавления выбранного датчика
                        this.selected_name = sp.name;
                        this.selected_dir = sp.dir;
                        //this.selected_date = this.analisisService.convertDate(sp.create_ts);
                        this.selected_status = sp.status_v;

                        //пробуем  подставлять title в селект через d3
                        d3.select('.sensor_select').select('.ng-value-container').attr('title', this.selected_name)
                    }
                }
            })
        });
        this.sensor_select.length > 0 ? this.fb_disabled = false : this.fb_disabled = true;
        this.sensor_select.length == 0 ? this.show_found = true : this.show_found = false;
    }
    clearSelect(){
        this.analisisService.changeData([]);
    }

    chooseDirStatus(draw: boolean){
        this.sensor_select = [];
        this.show_found = false;
        this.tmp_sensors = [];
        if(this.sensorProjectListDef.length > 0){
            this.status_select.forEach(s=>{
                this.dir_select.forEach(d=>{
                    this.sensorProjectListDef.forEach(sp=>{
                        if(sp.status_v == s && sp.dir == d){
                            this.tmp_sensors.push(sp);
                            this.sensor_select.push(sp.sensor_id);
                        }
                    });
                });
            });
            if(this.tmp_sensors.length == 1){
                let s_one = this.tmp_sensors[0];
                this.selected_name = s_one.name;
                this.selected_date = this.analisisService.convertDate(s_one.create_ts);
                this.selected_status = s_one.status_v;
                this.selected_dir = s_one.dir;
                this.selected_st_name = this.status_select[0].name;
                this.selected_st_status = this.status_select[0].name;
            }
            if(!this.tmp_sensors.length){
              this.show_found = true;
            }
        }
        this.sensor_select.length > 0 ? this.fb_disabled = false : this.fb_disabled = true;
        if(this.sensor_select.length == 0){
            this.show_found = true;
            this.sensorProjectList = this.tmp_sensors;
        }else{
            this.sensorProjectList = this.sensorProjectListDef;
        }
        if(draw){
            this.drawPoints(true);
        }
    }

    drawPoints(no_fit = true){
        //console.log('drawpoints run with no_fit: ', no_fit);
        this.isDataAvailable = false;
        // if(no_fit){
        //     this.isDataAvailable = false;
        // }
        if(this.noaccess){
            this.isDataAvailable = true;
            return false;
        }
        //console.log('this.markersList',this.markersList);

        //создаем массив с координатами датчиков для масштабирования карты по умолчанию, чтобы все датчики на карте были видны
        this.fit = [];
        if(Boolean(this.sensorProjectList) && this.sensorProjectList.length > 0){
            if(this.fromfilter){
                let filter_list = [];
                if(this.sensor_select != null && this.sensor_select.length > 0){
                    this.sensor_select.map(ss=>{
                        this.sensorProjectList.map(s=>{
                            if(ss == s.sensor_id){
                                filter_list.push(s);
                            }
                        });
                    });
                    this.sensorMap = filter_list;
                }

            }else{
                this.sensorMap = this.sensorProjectList;
            }
            if(Boolean(this.map)){
                this.sensorMap.map((sensor) => {
                    this.sensor.map(ss=>{
                        if(sensor.sensor_id == ss.sensor_id){
                            this.fit.push([sensor.configuration.gps_latitude, sensor.configuration.gps_longitude]);
                        }
                    });
                });
                if(this.fit.length > 0) {
                    this.dark_map = false;
                    if(no_fit){
                        this.map.fitBounds(this.fit,{maxZoom: 18, paddingBottomRight: [200,0]});
                        this.fitZoom = this.map.getZoom();
                    }
                    this.currentZoom = this.map.getZoom();

                    L.tileLayer.wms('https://smartroad.sorb-eng.ru/map/service?', {
                        layers: "osm",
                        format: "image/png",
                        srs: "EPSG:900913",
                        exceptions: "application/vnd.ogc.se_inimage",
                        transparent: true,
                        maxNativeZoom: 18,
                        maxZoom: 25
                    }, {
                        singleTile: true,
                        ratio: 1,
                        isBaseLayer: true
                    }).addTo(this.map);
                    let $this = this;
                    this.map.on("dragend", function () {
                        $this.touch_map = true;
                    });
                    this.markersIcons();
                }
            }
        }
    }
    //вывод собщениния, что нет датчиков в проекте
    noSensors(){
        this.dark_map = true; // затемняем карту если нет датчиков
        this.text_no_access = this.add_sensors_to_project;
        this.isDataAvailable = true;
    }

    //функция вывода маркеров различных цветов с инфо-попапом
    markersIcons(){
        //this.markersList = null;
        if(this.markersList !=null){
            this.map.removeLayer(this.markersList);
        }

        this.markersList = new L.LayerGroup();
        let $this = this;
        let icon: any;
        this.markersList.clearLayers();
        if(this.sensorMap.length ){
            if(this.sensorMap.length > 1){
                this.filter_both_show = true;
            }
            this.sensorMap.map((sensor) => {
                this.serial_number = sensor.serial_number;
                this.targetIp = sensor.ip;
                this.sensorId = sensor.sensor_id;
                this.statusList.map(status => {
                 if (sensor.status_v == status.code) {
                   this.sensorStatus = status.name;
                   this.sensorClass = status.class;
                 }
                });

                let activationDate = new Date(sensor.create_ts.replace(' ', 'T').slice(0, 19));
                let dataact = activationDate.toLocaleDateString();
                let lat_x = sensor.configuration.gps_latitude_x;
                let long_x = sensor.configuration.gps_longitude_x;
                this.sensor.map(item=> {
                    if (item.sensor_id == sensor.sensor_id) {
                        if (item.selected) {
                            switch(sensor.status_v){
                                case 0:
                                    if(lat_x != null && long_x != null){
                                        this.currentZoom > 16 ? icon = this.selectedIconInactiveDir : icon = this.selectedIconInactiveSmallDir;
                                    }else{
                                        this.currentZoom > 16 ? icon = this.selectedIconInactive : icon = this.selectedIconInactiveSmall;
                                    }
                                break;
                                case 1:
                                    if(lat_x != null && long_x != null){
                                        this.currentZoom > 16 ? icon = this.selectedIconActiveDir : icon = this.selectedIconActiveSmallDir;
                                    }else{
                                        this.currentZoom > 16 ? icon = this.selectedIconActive  : icon = this.selectedIconActiveSmall;
                                    }
                                break;
                                case 2:
                                    if(lat_x != null && long_x != null){
                                        this.currentZoom > 16 ? icon = this.selectedIconIdleDir : icon = this.selectedIconIdleSmallDir;
                                    }else{
                                        this.currentZoom > 16 ? icon = this.selectedIconIdle : icon = this.selectedIconIdleSmall;
                                    }
                                break;
                                case 3:
                                    if(lat_x != null && long_x != null){
                                        this.currentZoom > 16 ? icon = this.selectedIconDeletedDir : icon = this.selectedIconDeletedSmallDir;
                                    }else{
                                        this.currentZoom > 16 ? icon = this.selectedIconDeleted : icon = this.selectedIconDeletedSmall;
                                    }
                                break;
                                case 4:
                                  if(lat_x != null && long_x != null){
                                     this.currentZoom > 16 ? icon = this.selectedIconInServiceDir : icon = this.selectedIconInServiceSmallDir;
                                  }else{
                                     this.currentZoom > 16 ? icon = this.selectedIconInService : icon = this.selectedIconInServiceSmall;
                                  }
                                break;
                            }
                        }else{
                            switch(sensor.status_v){
                                case 0:
                                    if(lat_x != null && long_x != null){
                                        this.currentZoom > 16 ? icon = this.inactiveIconDir : icon = this.inactiveIconSmallDir;
                                    }else{
                                        this.currentZoom > 16 ? icon = this.inactiveIcon : icon = this.inactiveIconSmall;
                                    }
                                break;
                                case 1:
                                    if(lat_x != null && long_x != null){
                                        this.currentZoom > 16 ? icon = this.activeIconDir : icon = this.activeIconSmallDir;
                                    }else{
                                        this.currentZoom > 16 ? icon = this.activeIcon : icon = this.activeIconSmall;
                                    }
                                break;
                                case 2:
                                    if(lat_x != null && long_x != null){
                                        this.currentZoom > 16 ? icon = this.idleIconDir : icon = this.idleIconSmallDir;
                                    }else{
                                        this.currentZoom > 16 ? icon = this.idleIcon : icon = this.idleIconSmall;
                                    }
                                break;
                                case 3:
                                    if(lat_x != null && long_x != null){
                                        this.currentZoom > 16 ? icon = this.deletedIconDir : icon = this.deletedIconSmallDir;
                                    }else{
                                        this.currentZoom > 16 ? icon = this.deletedIcon : icon = this.deletedIconSmall;
                                    }
                                break;
                              case 4:
                                if(lat_x != null && long_x != null){
                                  this.currentZoom > 16 ? icon = this.inServiceIconDir : icon = this.inServiceIconSmallDir;
                                }else{
                                  this.currentZoom > 16 ? icon = this.inServiceIcon : icon = this.inServiceIconSmall;
                                }
                                break;
                            }
                        }
                    }
                });

                //вычисляем угол поворота маркера датчика
                if(lat_x != null && long_x != null){
                    let gps_latitude = sensor.configuration.gps_latitude;
                    let gps_longitude = sensor.configuration.gps_longitude;
                    let latlng1 = L.latLng(gps_latitude, gps_longitude);
                    let latlng2 = L.latLng(lat_x, long_x);
                    let bearing: number;
                    if(latlng1 != null && latlng2 != null){
                        bearing = this.bearing(latlng1,latlng2);
                        this.sensor_rotation = bearing;
                    }
                }

                // create popup contents
                let sensorId = '';
                let sensorIP = '';
                let place_info = '';
                let current_status = '';
                let serial_number = '';
                let activ_date = "<h4>" + this.activation_lang + "</h4>" +
                    "<p>" + dataact + "</p>";
                // let deleted_at = '';
                // let deleted_at_date = '';
                // // if(sensor.deleted_at != null){
                // //     deleted_at_date = new Date(sensor.deleted_at).toLocaleDateString();
                // //     deleted_at = "<h4>" + this.deleted_at_lang + "</h4>" +
                // //     "<p>" + deleted_at_date + "</p>"
                // // }

                if(sensor.loc != null){
                    place_info = "<h4>" + this.location_lang + "</h4>" + "<p>" + sensor['loc'] + "</p>";
                }
                let ad_status = [];
                if(Boolean(sensor.status_v_list)){
                    ad_status = sensor.status_v_list.split(',');
                    let ad_status_col = ad_status[0];
                    for (var i = 0; i < ad_status.length; i++) {
                        if(i != 0){
                            ad_status_col = ad_status_col + '<br />' + ad_status[i];
                        }

                    }
                    if (this.targetIp !== '') {
                      sensorId = "<span class='serial-num-translate'>" + this.sensor_id_translated + "</span><br><span class='serial-num'>" + this.sensorId + "</span><br>";
                      sensorIP = "<span class='serial-num-translate'>" + this.sensor_ip_translated  + "</span><br><span class='serial-num'>" + this.targetIp + "</span><br>";
                    }
                    if(sensor.deleted_at == null && sensor.status_v_list != ''){
                        serial_number = "<span class='serial-num-translate'>"+ this.serial_number_translated +"</span><br></span><span class='serial-num'>"+this.serial_number+"</span><br>";
                        current_status = "<h4>" + this.current_status_lang + "</h4>" + "<p class='map-popup-status'><span class="+ this.sensorClass +">" + this.sensorStatus +".</span><br>" + ad_status_col + "</p>";
                    }
                }

                let sensor_name = "<p class='map-popup-head'>"+ sensor.name +"</p>";

                //новый попап маркера датчика
                const customPopup = R.responsivePopup({ hasTip: true, autoPan: false, offset: [10, 20]})
                .setContent(
                    sensor_name +
                         sensorId +
                         sensorIP +
                         serial_number +
                         current_status +
                         place_info +
                         activ_date
                );

                if(Boolean(icon)){
                    this.markersList.addLayer(L.marker([sensor.configuration.gps_latitude, sensor.configuration.gps_longitude], {
                    icon: icon,
                    rotationAngle: this.sensor_rotation, //направление маркера
                    rotationOrigin:'50% 50%' //точка поворота маркера
                    }).bindPopup(customPopup).addTo(this.map)
                        .on('dblclick', function () {
                            $this.sensor.map((item, index) => {
                                if (item.sensor_id == sensor.sensor_id) {
                                    $this.sensor[index].selected = true;
                                }else{
                                    $this.sensor[index].selected = false;
                                }
                            });
                            let sel_list = $this.analisisService.selectedSensorsGlobDef;
                            if(sel_list.length > 0){
                                if(sel_list.length == 1){
                                    $this.router.navigate(['report/sensor-statistics']);
                                }else{
                                    $this.router.navigate(['report/consolidated-statistics']);
                                }
                            }

                        }).on('click', function (e: { target: { setIcon: (arg0: any) => any; }; }) {
                            this.closePopup();
                            $this.sensor.map((item) => {
                                if (item.sensor_id == sensor.sensor_id) {
                                    if (item.selected) {
                                        item.selected = false;
                                        switch(sensor.status_v){
                                            case 0:
                                                if(lat_x != null && long_x != null){
                                                    $this.currentZoom > 16 ? e.target.setIcon($this.inactiveIconDir) : e.target.setIcon($this.inactiveIconSmallDir);
                                                }else{
                                                    $this.currentZoom > 16 ? e.target.setIcon($this.inactiveIcon) : e.target.setIcon($this.inactiveIconSmall);
                                                }
                                            break;
                                            case 1:
                                                if(lat_x != null && long_x != null){
                                                    $this.currentZoom > 16 ? e.target.setIcon($this.activeIconDir) : e.target.setIcon($this.activeIconSmallDir);
                                                }else{
                                                    $this.currentZoom > 16 ? e.target.setIcon($this.activeIcon) : e.target.setIcon($this.activeIconSmall);
                                                }
                                            break;
                                            case 2:
                                                if(lat_x != null && long_x != null){
                                                    $this.currentZoom > 16 ? e.target.setIcon($this.idleIconDir) : e.target.setIcon($this.idleIconSmallDir);
                                                }else{
                                                    $this.currentZoom > 16 ? e.target.setIcon($this.idleIcon) : e.target.setIcon($this.idleIconSmall);
                                                }
                                            break;
                                            case 3:
                                                if(lat_x != null && long_x != null){
                                                    $this.currentZoom > 16 ? e.target.setIcon($this.deletedIconDir) : e.target.setIcon($this.deletedIconSmallDir);
                                                }else{
                                                    $this.currentZoom > 16 ? e.target.setIcon($this.deletedIcon) : e.target.setIcon($this.deletedIconSmall);
                                                }
                                            break;
                                            case 4:
                                                if(lat_x != null && long_x != null){
                                                    $this.currentZoom > 16 ? e.target.setIcon($this.inServiceIconDir) : e.target.setIcon($this.inServiceIconSmallDir);
                                                }else{
                                                    $this.currentZoom > 16 ? e.target.setIcon($this.inServiceIcon) : e.target.setIcon($this.inServiceIconSmall);
                                                }
                                            break;
                                        }

                                    }else {
                                        item.selected = true;
                                        switch(sensor.status_v){
                                            case 0:
                                                if(lat_x != null && long_x != null){
                                                    $this.currentZoom > 16 ? e.target.setIcon($this.selectedIconInactiveDir) : e.target.setIcon($this.selectedIconInactiveSmallDir);
                                                }else{
                                                    $this.currentZoom > 16 ? e.target.setIcon($this.selectedIconInactive) : e.target.setIcon($this.selectedIconInactiveSmall);
                                                }
                                            break;
                                            case 1:
                                                if(lat_x != null && long_x != null){
                                                    $this.currentZoom > 16 ? e.target.setIcon($this.selectedIconActiveDir) : e.target.setIcon($this.selectedIconActiveSmallDir);
                                                }else{
                                                    $this.currentZoom > 16 ? e.target.setIcon($this.selectedIconActive)  : e.target.setIcon($this.selectedIconActiveSmall);
                                                }
                                            break;
                                            case 2:
                                                if(lat_x != null && long_x != null){
                                                    $this.currentZoom > 16 ? e.target.setIcon($this.selectedIconIdleDir) : e.target.setIcon($this.selectedIconIdleSmallDir);
                                                }else{
                                                    $this.currentZoom > 16 ? e.target.setIcon($this.selectedIconIdle) : e.target.setIcon($this.selectedIconIdleSmall);
                                                }
                                            break;
                                            case 3:
                                                if(lat_x != null && long_x != null){
                                                    $this.currentZoom > 16 ? e.target.setIcon($this.selectedIconDeletedDir) : e.target.setIcon($this.selectedIconDeletedSmallDir);
                                                }else{
                                                    $this.currentZoom > 16 ? e.target.setIcon($this.selectedIconDeleted) : e.target.setIcon($this.selectedIconDeletedSmall);
                                                }
                                            break;
                                            case 4:
                                                if(lat_x != null && long_x != null){
                                                    $this.currentZoom > 16 ? e.target.setIcon($this.selectedIconInServiceDir) : e.target.setIcon($this.selectedIconInServiceSmallDir);
                                                }else{
                                                    $this.currentZoom > 16 ? e.target.setIcon($this.selectedIconInService) : e.target.setIcon($this.selectedIconInServiceSmall);
                                                }
                                            break;
                                        }
                                    }
                                }
                            });
                            //помещаем выделенные датчики в глобальный сервис
                            let selected_sensors_temp = [];
                            $this.sensor.forEach(ss=>{
                                if(ss.selected){
                                    selected_sensors_temp.push(ss);
                                }
                            })
                            if(selected_sensors_temp.length > 0){
                                $this.analisisService.changeData(selected_sensors_temp);
                            }else{
                                $this.analisisService.changeData([]);
                            }
                        }).on('mouseover', function () {
                                this.openPopup();
                        }).on('mouseout', function () {
                            this.closePopup();
                        })
                        );
                }
              // Call func that adds sensor error icons.
              if (sensor.warnings_number && sensor.status_v != 3) {
                this.sensor_object = { ... sensor};
                this.addSensorWarnings(this.sensor_object);
              }

            });
            this.map.addLayer(this.markersList);
            this.isDataAvailable = true;
            //вывод инцидентов
            //проверяем, если эта функция запущена при включенном фильтре и смене статуса датчиков
            if(!Boolean(this.incs) && this.status_select.length < 4 && this.eventsShow){
                this.loadInc();
            }else{
                if(Boolean(this.incs) && this.incs.length > 0 && this.eventsShow){
                    if(this.target_event_id != 0){
                        this.printInc(this.target_event_id);
                    }else{
                        this.printInc(0);
                    }

                }else{
                    if(!Boolean(this.incs) && this.eventsShow){
                        this.loadInc();
                    }
                }
            }
            this.loadIncLast();

        }
        //this.isDataAvailable = true;
    }
    //тест для открытия попапов фильтра инцидентов
    showIncSubtipes(t: { type: string | number; }) {
      Object.keys(this.hideme).forEach(h => {
        this.hideme[h] = false;
      });
      this.hideme[t.type] = true;
    }

    loadTypes(){
        // загрузка типов из словаря
        this.http.get('/api/events/events_level').subscribe((res:HttpResponse<any>) => {
            this.Globals.catList = res.body;
            this.Globals.catList.map(cat => {
                cat.name = JSON.parse(cat.name);
            });
            //временно, пока не сделано в базе, добаляем испанский и копируем в него английское значение
            for (var c = 0; c < this.Globals.catList.length; c++) {
                if(!Boolean(this.Globals.catList[c].name.es)){
                    this.Globals.catList[c].name.es = this.Globals.catList[c].name.en;
                }
            }
            this.incidents_critical_lang = this.Globals.catList[2].name;
            this.incidents_warning_lang = this.Globals.catList[1].name;
            this.incidents_info_lang = this.Globals.catList[0].name;
            this.http.get('/api/events/events_type').subscribe((res:HttpResponse<any>) => {
                this.Globals.typeList = res.body;
                //парсим имя из строки в массив
                this.Globals.typeList.map(t => {
                    t.name = JSON.parse(t.name);
                });
                //временно, пока не сделано в базе, добаляем испанский и копируем в него английское значение
                for (var t = 0; t < this.Globals.typeList.length; t++) {
                    if(!Boolean(this.Globals.typeList[t].name.es)){
                        this.Globals.typeList[t].name.es = this.Globals.typeList[t].name.en;
                    }
                }
            });
        }, (error) => {
            if (error.status !== 401 && error.status !== 403 && error.status !== 423 && this.Globals.error) {
                this.Globals.error = false;
                this.dialog.open(CreateDialogComponent, < MatDialogConfig > {
                    data: {
                        act: "error",
                        text: this.error_data,
                        reset_event: true,
                        icon_class:"dialog-icon-warning"
                    }
                });
                this.isDataAvailable = true;
            }
        });
    }
    // setDateBorders(type_date_arr: any[]) {

    //     let date_after_number = new Date(this.analisisService.dateAfter).getTime();
    //     let date_before_number = new Date(this.analisisService.dateBefore).getTime();
    //     let current = new Date();

    //     //console.log('type_date_arr', type_date_arr);
    //     let received_date = type_date_arr[0].length < 19 ? type_date_arr[0] + ' 00:00:00' : type_date_arr[0];
    //     let index = type_date_arr[1];
    //     let day_check_picked = dayjs(received_date, 'DD.MM.YYYY HH:mm:ss', true).isValid();
    //     let date_number = dayjs(received_date, 'DD.MM.YYYY HH:mm:ss', true).valueOf();

    //     if (!day_check_picked) {
    //         switch (index) {
    //           case 1:
    //             this.inc_date_before_error = true;
    //             break;
    //           case 2:
    //             this.inc_date_after_error= true;
    //             break;
    //         }
    //     } else {
    //         switch (index) {
    //           case 1:
    //             this.inc_date_before_error = false;
    //             if(date_after_number < date_number || date_number>current.getTime()){
    //                 this.inc_date_before_error = true;
    //             }else{
    //                 this.inc_date_before_error = false;
    //             }
    //             break;
    //           case 2:
    //             this.inc_date_after_error = false;
    //             if(date_before_number > date_number){
    //                 this.inc_date_before_error = true;
    //             }else{
    //                 this.inc_date_before_error = false;
    //             }
    //             if(date_number>current.getTime()){
    //                 this.inc_date_after_error= true;
    //             }else{
    //                 this.inc_date_after_error= false;
    //             }
    //             break;
    //         }
    //     }

    //     if(this.inc_date_before_error || this.inc_date_after_error){
    //         this.filterIncDisabled = true;
    //     }else{
    //         this.eventsShow ? this.filterIncDisabled = false : this.filterIncDisabled = true;
    //     }
    // }
    // correctIncPeriod(num: any, event?: any){
    //     //console.log('date event', event)
    //     let start = new Date(this.analisisService.dateBefore).getTime();
    //     let finish = new Date(this.analisisService.dateAfter).getTime();
    //     let current = new Date();
    //     let mask = "__.__.____ __:__:__";
    //     if(event == mask){
    //         switch(num) {
    //             case 1:
    //                 this.inc_date_before_error = true;
    //             break;

    //             case 2:
    //                 this.inc_date_after_error = true;
    //             break;
    //         }
    //     }

    //     //если дата дата «после» или дата «до» больше текущей даты, ставим текущую дату
    //     // if(start > current.getTime()){
    //     //     this.analisisService.dateBefore = current;
    //     //     this.analisisService.dateAfter = current;
    //     // }
    //     // if(finish > current.getTime()){
    //     //     this.analisisService.dateAfter = current;
    //     // }

    //     //если дата «до» больше даты «после», делаем дату «до» = дате «после»
    //     if(finish > 0 && start > 0 && start > finish){
    //         //console.log('working?', event);
    //         this.analisisService.dateBefore = '';
    //         //this.analisisService.dateBefore = this.analisisService.dateAfter;
    //     }
    //     //выводим красный бордер, если дата ошибочна, но не пуста
    //     let num_time_before = new Date(this.analisisService.dateBefore).getTime();
    //     let num_time_after = new Date(this.analisisService.dateAfter).getTime();

    //     switch(num) {
    //         case 1:
    //             if(isNaN(num_time_before) && this.analisisService.dateBefore != mask){
    //                 this.inc_date_before_error = true;
    //                 this.filterIncDisabled = true;
    //             }
    //             else{
    //                 this.inc_date_before_error = false;
    //                 this.eventsShow ? this.filterIncDisabled = false : this.filterIncDisabled = true;
    //             }
    //             if(this.analisisService.dateBefore == mask){
    //                 this.analisisService.dateBefore = new Date(this.min_date);
    //             }
    //         break;
    //         case 2:
    //             if(isNaN(num_time_after) && this.analisisService.dateAfter != mask){
    //                 this.inc_date_after_error = true;
    //                 this.filterIncDisabled = true;
    //             }
    //             else{
    //                 this.inc_date_after_error = false;
    //                 this.eventsShow ? this.filterIncDisabled = false : this.filterIncDisabled = true;
    //             }
    //             if(this.analisisService.dateAfter == mask){
    //                 this.analisisService.dateAfter = current;
    //             }
    //         break;
    //     }

    //    // Set a red border if the month value > 12 or the day value > 31
    //     let date_array: number[];
    //     if(event && event.indexOf('.') > -1) {
    //             date_array = event.split(/\.|:|' '/).map((item: any) => Number(item));
    //         if ( num == 1) {
    //             this.inc_date_before_error = date_array[0] > 31 || date_array[1] > 12;
    //             this.filterIncDisabled = this.inc_date_before_error;
    //         }
    //         if (num == 2) {
    //             this.inc_date_after_error = date_array[0] > 31 || date_array[1] > 12;
    //             this.filterIncDisabled = this.inc_date_after_error;
    //         }
    //     }
    // }
    // срабатывание фильтра инцидентов в зависимости от выбранных параметров
    applyIncfilter(scale: any){
        this.inc_project = [];
        this.incTypeList = [];
        this.last_show = false;
        this.filteredTypesCheck = [];
        this.eventsByFilter = true;

        if(scale){
            this.reset_inc = true;
            this.from_filter = true;
        }
        this.reload_checked = true;
        this.filteredTypes.forEach(ft => {
            if (ft.checked){
                this.filteredTypesCheck.push(ft.code);
            }
        });
        //console.log('this.filteredTypesCheck',this.filteredTypesCheck);

        if(this.filteredTypesCheck.length == 0){
            this.dialog.open(CreateDialogComponent, < MatDialogConfig > {
                data: {
                    action: "",
                    text: this.check_event_types_lang,
                    icon_class:"dialog-icon-warning"
                }
            });
            return false;
        }
        this.reloadInc();
        this.last_event_loading = true;
        if(scale){
          this.set_scale = true;
        }

        //считаем кол-во заполненных поелй в фильтре
        this.filterNumber = (this.numberEvents != this.inc_def_number) ? 1 : 0;

        //отмечаем если изменен период
        this.filterDate = ((this.min_date.getTime() != new Date(this.analisisService.dateBefore).getTime()) || (new Date(this.analisisService.dateAfter).getTime() != this.load_date.getTime())) ? 1 : 0;

        //считаем кол-во отмеченных типов
        this.chFilterTypes = 0;
        this.filteredTypes.forEach(t=>{
            if(t.checked){
                this.chFilterTypes++;
            }
        })
        if(this.chFilterTypes > 0 && this.chFilterTypes < 3){
            this.colorTypesSel = [];
            // добавляем цвета отмеченных типов для закрытого фильтра
            this.filteredTypes.forEach(tc=>{
                if(tc.code =='0'){
                    tc['color'] = "#6aa6ec";
                }
                if(tc.code =='1'){
                    tc['color'] = "#ee8703";
                }
                if(tc.code =='2'){
                    tc['color'] = "#e33052";
                }
                if(tc.checked){
                    this.colorTypesSel.push(tc);
                }
            });
        }


        this.filterTypes = (this.chFilterTypes < this.filteredTypes.length) ? 1 : 0;
        this.filterShowInc = this.eventsShow ? 0 : 1;

        this.params_number_inc = this.filterNumber + this.filterDate + this.filterTypes + this.filterShowInc;
    }
    setScale(){
        // функция для сброса масштаба карты после использования фильтра
        //console.log('run setScale()');
        let latlng = [];
        if(Boolean(this.inc_project[0])){
            let inc = this.inc_project[0];
            if(Boolean(inc.inc_lat) && Boolean(inc.inc_long)){
                latlng = [inc.inc_lat,inc.inc_long];
                this.map.setView(latlng, 20);
                this.set_scale = false;
            }
        }
    }
    //сброс фильтра инцидентов
    resetIncFilter(scale: boolean){
        this.filter_inc_count = 0;
        // this.filter_both_show_inc = true;
        // this.from_disabled_show_inc = true;
        this.eventsByFilter = false;
        this.analisisService.dateBefore = this.min_date;
        this.analisisService.dateAfter = new Date();
        this.load_date = this.analisisService.dateAfter;
        this.inc_project = [];
        this.numberEvents = this.inc_def_number;
        this.type_loading = true;
        this.eventsShow = true;
        this.inc_num_sel_show = true;
        this.reset_action = true;
        this.incTypeList = [];
        this.filteredTypes = [];
        this.filteredTypesCheck = this.filteredTypesCheckDef;
        this.from_filter = false;
        this.reload_checked = true;
        this.changeNum = true;
        this.wait_reset_inc = false;
        this.reloadInc();
        scale ? this.set_scale = true: this.set_scale = false;
    }
    //функция вызывается для получения последнего события с учетом фильтра
    loadIncLast(){
        let send_project_id: string;
        if(Boolean(this.Globals.select_project)){
            send_project_id = this.Globals.select_project;
        }
        let params: HttpParams= new HttpParams();
        params = params
            .set('projects_id', send_project_id)
            .set('numberEvents', "1")
            .set('filteredTypesCheck', this.filteredTypesCheck.toString());

        //if(this.checkProj()){
        if(Boolean(this.Globals.select_project)){
            send_project_id = this.Globals.select_project;
        }

        if(Boolean(this.http_events_check)){
            this.http_events_check.unsubscribe();
        }
        if(Boolean(this.incs)){
            //this.inc_last = [];
            this.check_last_event_done = false;
            this.http_events_check = this.http.get('/api/incidents/inc_data', { params }).subscribe((res:HttpResponse<any>) => {
                this.inc_last = res.body;
                this.check_last_event_done = true;
                if(this.inc_last.length > 0 && Boolean(this.inc_last[0])){

                    //округляем скорость
                    this.inc_last[0].obj_speed = Math.round(this.inc_last[0].obj_speed * 100) / 100;

                    //форматируем время
                    this.inc_last[0].start_time_new = this.createDateAsUTC(new Date(this.inc_last[0].start_time.replace(' ', 'T').slice(0, 19)));

                    let descr = JSON.parse(this.inc_last[0].description);
                    //console.log(descr);
                    //временно, пока не сделано в базе, добавляем испанский и копируем в него английское значение
                    if(!Boolean(descr[2]) && Boolean(descr[1])){
                        descr[2] = {"lang": "es", "name": descr[1].name};
                    }
                    //если нет 2 и 3 копируем туда первое
                    if(!Boolean(descr[1]) && !Boolean(descr[2]) && Boolean(descr[0])){
                        descr[1] = {"lang": "en", "name": descr[0].name};
                        descr[2] = {"lang": "es", "name": descr[0].name};
                    }
                    //если вообще нет имени, пишем «не указано»
                    if(!Boolean(descr) || !descr.length){
                        descr[0] = {"lang": "ru", "name": "не указано"};
                        descr[1] = {"lang": "en", "name": "not defined"};
                        descr[2] = {"lang": "es", "name": "no definido"};
                    }

                    let lvl = parseInt(this.inc_last[0].level);

                    descr.map((d: { lang: string; name: string; })=>{
                        if(d.lang == this.Globals.lang){
                            this.inc_last_name = d.name;
                        }
                    })
                    if(lvl == 0){
                        this.inc_last_class = "inc_li_l_blue";
                    }
                    if(lvl == 1){
                        this.inc_last_class = "inc_li_orange";
                    }
                    if(lvl == 2){
                        this.inc_last_class = "inc_li_red";
                    }

                    let inc_date_before = new Date(this.analisisService.dateBefore);
                    let inc_date_after = new Date(this.analisisService.dateAfter);
                    if(inc_date_before.getTime()> 0 && inc_date_after.getTime()> 0){
                        let inc_date_after_utc = this.convertDateToUTCmac(inc_date_after);
                        if(inc_date_after_utc.getTime() > inc_date_after.getTime()){
                            this.filter_inc_count ++;
                        }
                    }

                    //добавляем в начало массива новое событие, а из конца массива последнее удаляем

                    if(this.filter_inc_count == 2 && Boolean(this.inc_project[0]) && this.inc_project[0].start_time != this.inc_last[0].start_time){
                        this.inc_project.unshift(this.inc_last[0]);
                        if(this.inc_project.length > this.numberEvents){
                            this.inc_project.pop();
                        }
                        if(this.eventsShow){

                            //this.map.removeLayer(this.incs_test_clust);
                            this.incs_test_clust.clearLayers();

                            this.printInc(0);
                            this.last_event_loading = false;
                        }
                    }
                    this.last_event_loading = false;
                    let time_now = new Date().getTime();
                    let ev_date: number;
                    if(Boolean(this.inc_last[0])){
                        ev_date = new Date(this.inc_last[0].start_time).getTime();
                    }
                    let diff = time_now - ev_date;

                    if(diff > 0 && diff < 60000){
                        this.blink_date = true;
                        setTimeout(()=>this.blink_date = false, 10000);
                    }
                    if(this.eventsShow){
                        this.show_last_event = true;
                    }
                    this.inc_last_data = this.inc_last[0];
                }
            });
        }
    }
    goToEvent(id: string){
        this.target_event_id = 0;
        //console.log('run goToEvent', id);
        this.go_last_event_flag = true;

        this.isDataAvailable = false;
        this.wait_reset_inc = false;
        this.ev_list_id = id;
        this.last_show = false;
        this.eventsShow = true;
        this.from_disabled_show_inc = true;
        let latlng = [];
        let inc = this.inc_project[0];

        //к последнему событию если его нет на карте
        if(this.inc_last[0].events_id != inc.events_id){
            this.wait_reset_inc = true;
            this.resetIncFilter(true); //к последнему событию
        }else{
            //к последнему событию если оно уже есть на карте
            this.printInc(0);
            if(Boolean(inc)){
                if(Boolean(inc.inc_lat) && Boolean(inc.inc_long)){
                    latlng = [inc.inc_lat,inc.inc_long];
                    this.map.setView(latlng, 20);
                    this.isDataAvailable = true;
                }
                else {
                    alert ('No event coordinates');
                    this.isDataAvailable = true;
                }
            }
        }
    }
    goToWaitEvent(){
        this.isDataAvailable = false;
        //console.log('run goToWaitEvent');
        let inc = this.inc_project[0];
        let latlng = [];
        if(Boolean(inc) && Boolean(this.inc_last[0]) && this.inc_last[0].events_id == inc.events_id){
            if(Boolean(inc.inc_lat) && Boolean(inc.inc_long)){
                latlng = [inc.inc_lat, inc.inc_long];
                this.map.setView(latlng, 20);
            }
        }
    }

    goToListEvent(id: string){
        //this.isDataAvailable = false;
        this.target_event_id = id;
        //console.log('run goToListEvent', id);
        this.ev_list_id = id;
        let latlng = [];
        const index = this.inc_project.findIndex(inc => inc.events_id === id);
        let targ_inc = this.inc_project[index];

        if(Boolean(targ_inc)){
            if(Boolean(targ_inc.inc_lat) && Boolean(targ_inc.inc_long)){
                this.printInc(id);
                latlng = [targ_inc.inc_lat,targ_inc.inc_long];
                this.map.setView(latlng, 20);
            }
            else {
                alert ('No event coordinates');
            }
        }
    }

    // функция вывода инцидентов на карту
    printInc(id: string | number){
        //console.log('run printInc');
        let $this = this;
        let incs_test = new L.LayerGroup();
        // задаем список событий для фильтра
        this.eventsFilterList = [];
        if(Boolean($this.incs_test_clust)){
        //let incs_test:any = null;

        incs_test.clearLayers();
        //this.incs_layer = [];
            this.map.removeLayer($this.incs_test_clust);
            $this.incs_test_clust.clearLayers();
        }
        this.incs_test_clust = L.markerClusterGroup({
            spiderfyOnMaxZoom: true,
            showCoverageOnHover: false,
            disableClusteringAtZoom: 20,
            removeOutsideVisibleBounds: false,
            iconCreateFunction: function(cluster) {
                let cl_count = cluster.getChildCount();
                // получаем кол-во 3 различных типов инцидентов

                let new_inc_cluster_class = '';

                let count_inc_critical = cluster.getAllChildMarkers().filter((x: { options: { icon: { options: { className: string; }; }; }; }) => x.options.icon.options.className === 'inc-critical').length;
                let count_inc_critical_new = cluster.getAllChildMarkers().filter((x: { options: { icon: { options: { className: string; }; }; }; }) => x.options.icon.options.className === 'inc-critical new_inc').length;
                    if(count_inc_critical_new > 0){
                        new_inc_cluster_class = ' ' + 'inc-critical new_inc';
                    }

                let count_inc_warning = cluster.getAllChildMarkers().filter((x: { options: { icon: { options: { className: string; }; }; }; }) => x.options.icon.options.className === 'inc-warning').length;

                let count_inc_warning_new = cluster.getAllChildMarkers().filter((x: { options: { icon: { options: { className: string; }; }; }; }) => x.options.icon.options.className === 'inc-warning new_inc').length;
                    if(count_inc_warning_new > 0){
                        new_inc_cluster_class = ' ' + 'inc-warning new_inc';
                    }

                let count_inc_info = cluster.getAllChildMarkers().filter((x: { options: { icon: { options: { className: string; }; }; }; }) => x.options.icon.options.className === 'inc-info').length;
                let count_inc_info_new = cluster.getAllChildMarkers().filter((x: { options: { icon: { options: { className: string; }; }; }; }) => x.options.icon.options.className === 'inc-info new_inc').length;
                    if(count_inc_info_new > 0){
                        new_inc_cluster_class = ' ' + 'inc-info new_inc';
                    }

                let cc_str = {'num':(count_inc_critical+count_inc_critical_new), 'name':"count_inc-critical", 'class': "cl-bg-1",'size': 0, 'new':count_inc_critical_new};
                let cw_str = {'num':(count_inc_warning+count_inc_warning_new), 'name':"count_inc-warning", 'class': "cl-bg-2",'size': 0, 'new':count_inc_warning_new};
                let ci_str = {'num':(count_inc_info+count_inc_info_new), 'name':"count_inc-info", 'class': "cl-bg-3",'size': 0, 'new':count_inc_info_new};
                // складываем их в массив
                let cl_array = [
                    cc_str,
                    cw_str,
                    ci_str
                ];

                // сортируем

                let cl_array_sort = cl_array.sort((a,b) => b.num - a.num);

                //добавляем размер цветного слоя кластера с условиями, пытаемся построить алгоритм

                cl_array_sort.map((type)=>{

                    let cl_size = 0;
                    cl_size = type.num * $this.cl_co;

                    if(type.num <= $this.cl_min){
                        cl_size = (type.num * $this.cl_co) * ($this.cl_co / type.num);
                    }
                    type.size = cl_size;
                });

                // если у разных типов одинаковое кол-во

               function changeDuplicates(){
                    for (var i = 0; i < cl_array_sort.length; i++) {
                        for (var j = i; j < cl_array_sort.length; j++) {
                            if(i == j)continue;

                            if(cl_array_sort[i].size == cl_array_sort[j].size && cl_array_sort[i].size != 0){
                                cl_array_sort[i].size = cl_array_sort[i].size + $this.cl_co * (cl_array_sort.length - i);
                            }
                        }
                    }
                }

                //  запускаем 2 раза, так как может появиться новый дубликат, например: было 1-2-2, после проверки стало 1-1-2.

                changeDuplicates();
                changeDuplicates();

                // помещаем значения из массива в html-код кластера
                let cluster_icon: any;
                let new_event = false;
                cl_array_sort.map(cl=>{
                    if(cl.new != 0){
                       new_event = true;
                       return false;
                    }
                });
                if(new_event){

                    cluster_icon = L.divIcon({
                        className: 'cl-default',
                        html: '<div class="inc-cluster-all-box"><div class="cl-number' + new_inc_cluster_class + '">' + cl_count + '</div><div class="inc-cluster-box"><div class="inc-cluster cl-1 ' + cl_array_sort[0].class +'" style = "width:' + cl_array_sort[0].size +'px;height:' + cl_array_sort[0].size +'px;border-radius:' + cl_array_sort[0].size/2 +'px;"></div><div class="inc-cluster cl-2 ' + cl_array_sort[1].class +'" style = "width:' + cl_array_sort[1].size +'px;height:' + cl_array_sort[1].size +'px;border-radius:' + cl_array_sort[1].size/2 +'px"></div><div class="inc-cluster cl-3 ' + cl_array_sort[2].class +'" style = "width:' + cl_array_sort[2].size +'px;height:' + cl_array_sort[2].size +'px;border-radius:' + cl_array_sort[2].size/2 +'px"></div></div></div>'
                    });

                }else{
                    cluster_icon = L.divIcon({
                        className: 'cl-default',
                        html: '<div class="inc-cluster-all-box"><div class="cl-number">' + cl_count + '</div><div class="inc-cluster-box"><div class="inc-cluster cl-1 ' + cl_array_sort[0].class +'" style = "width:' + cl_array_sort[0].size +'px;height:' + cl_array_sort[0].size +'px;border-radius:' + cl_array_sort[0].size/2 +'px;"></div><div class="inc-cluster cl-2 ' + cl_array_sort[1].class +'" style = "width:' + cl_array_sort[1].size +'px;height:' + cl_array_sort[1].size +'px;border-radius:' + cl_array_sort[1].size/2 +'px"></div><div class="inc-cluster cl-3 ' + cl_array_sort[2].class +'" style = "width:' + cl_array_sort[2].size +'px;height:' + cl_array_sort[2].size +'px;border-radius:' + cl_array_sort[2].size/2 +'px"></div></div></div>'
                    });
                }
            //переносли сюда создание попапа
            //попап с числом инцидентов общим и по типам

            let cl_period_arr = [];
            if(Boolean(cluster)){
                cluster.getAllChildMarkers().map((m) => {
                    cl_period_arr.push(new Date(m.options.alt));
                });
            }
            let maxDate = $this.createDateAsUTC(new Date(Math.max.apply(null,cl_period_arr)));
            let minDate = $this.createDateAsUTC(new Date(Math.min.apply(null,cl_period_arr)));
            $this.def_period = minDate + '—' + maxDate;

            let count_all = cluster.getAllChildMarkers().length;
            let cic = cluster.getAllChildMarkers().filter((x: { options: { icon: { options: { className: string; }; }; }; }) => x.options.icon.options.className === 'inc-critical').length;
            let cic_new = cluster.getAllChildMarkers().filter((x: { options: { icon: { options: { className: string; }; }; }; }) => x.options.icon.options.className === 'inc-critical new_inc').length;
            let ciw = cluster.getAllChildMarkers().filter((x: { options: { icon: { options: { className: string; }; }; }; }) => x.options.icon.options.className === 'inc-warning').length;
            let ciw_new = cluster.getAllChildMarkers().filter((x: { options: { icon: { options: { className: string; }; }; }; }) => x.options.icon.options.className === 'inc-warning new_inc').length;
            let cii = cluster.getAllChildMarkers().filter((x: { options: { icon: { options: { className: string; }; }; }; }) => x.options.icon.options.className === 'inc-info').length;
            let cii_new = cluster.getAllChildMarkers().filter((x: { options: { icon: { options: { className: string; }; }; }; }) => x.options.icon.options.className === 'inc-info new_inc').length;
            let cic_li = (cic+cic_new) != 0 ? ('<li class="inc_li_red">' + (cic+cic_new) + '  ' + $this.incidents_critical_lang[$this.Globals.lang] + '</li>') : '';
            let ciw_li = (ciw+ciw_new) != 0 ? ('<li class="inc_li_orange">' + (ciw+ciw_new) + '  ' + $this.incidents_warning_lang[$this.Globals.lang] + '</li>') : '';
            let cii_li = (cii+cii_new) != 0 ? ('<li class="inc_li_l_blue">' + (cii+cii_new) + '  ' + $this.incidents_info_lang[$this.Globals.lang] + '</li>') : '';
            let count_types = cic_li + ciw_li + cii_li;

            // новый попап для кластера // попап с числом инцидентов общим и по типам
            const popHtml = '<div class="cl-popup-top"><div class="cl-popup-top-right">' + $this.def_period + '</div></div><div class="cl-popup-sum">' + $this.incidents_lang + ': ' + count_all + '</div><ul class="cl_list">' + count_types + '</ul>';
            $this.createAndBindPopUp(cluster, popHtml);
            return cluster_icon;
            }


        }).on('clustermouseover', (a) => {
            a.sourceTarget.openPopup();
        }).on('clustermouseout', (a: { sourceTarget: { closePopup: () => void; }; }) => {
            a.sourceTarget.closePopup();
        });

        // делаем массив инциндентов для вывода
        if(Boolean(this.incs)){
            if(this.inc_project.length == 0){
                this.inc_project = JSON.parse(JSON.stringify(this.incs));
            }
        }

        // добавляем в массив инциндентов координаты
        this.inc_project.map(inc =>{
            this.tmp_inc_coord = null;
            this.sensorProjectList.map((sensor) => {
                if(sensor.sensor_id == inc.sensor_id){
                    this.tmp_az = sensor.configuration.azimut;
                    this.tmp_latlng1 = L.latLng(sensor.configuration.gps_latitude, sensor.configuration.gps_longitude);
                    this.tmp_latlng2 = L.latLng(sensor.configuration.gps_latitude_x, sensor.configuration.gps_longitude_x);
                    this.tmp_bearing = null;
                    if(this.tmp_latlng1 != null && this.tmp_latlng2 != null){
                        this.tmp_bearing = this.bearing(this.tmp_latlng1, this.tmp_latlng2);
                    }

                    if (this.tmp_az > 180.0) {
                        this.tmp_az = (this.tmp_az - 360.0) * (Math.PI/180.0);
                    }else{
                        this.tmp_az = this.tmp_az * (Math.PI/180.0);
                    }

                    //корректируем Х и У в зависимости от азимута
                    this.tmp_point_x = inc.point_x * Math.cos(this.tmp_az) - inc.point_y * Math.sin(this.tmp_az);
                    this.tmp_point_y = inc.point_x * Math.sin(this.tmp_az) + inc.point_y * Math.cos(this.tmp_az);


                    if(this.tmp_bearing != null){
                        this.tmp_bearing -= Math.atan(this.tmp_point_y/this.tmp_point_x)*(180.0/Math.PI);

                        //проверяем на isNaN

                        if(isNaN(this.tmp_bearing)){
                           this.tmp_bearing = 0;
                        }

                        this.tmp_inc_coord = this.destination(this.tmp_latlng1, this.tmp_bearing, Math.sqrt(this.tmp_point_x**2 + this.tmp_point_y**2));
                    }

                    //console.log('bearing ' + sensor.name +': ' + bearing);
                }
            });
            //console.log('this.tmp_inc_coord',this.tmp_inc_coord);

            if(Boolean(this.tmp_inc_coord) && this.tmp_inc_coord != null){
                inc.inc_lat = this.tmp_inc_coord.lat;
                inc.inc_long = this.tmp_inc_coord.lng;
            }
        })

        if(this.inc_project.length > 0){

            for (let i = 0; i < this.inc_project.length; i++) {
                let a = this.inc_project[i];
                let sensor_name = a.sensor_name;
                let inc_level = a.level;
                let inc_type_name: string;

                let inc_name: string;
                let descrip = a.description;
                if(Array.isArray(descrip)){
                    descrip.map(d=>{
                        if(d.lang == this.Globals.lang){
                           inc_name = d.name;
                        }
                    });
                }else{
                    descrip = JSON.parse(a.description);
                    descrip.map((d: { lang: string; name: string; })=>{
                        if(d.lang == this.Globals.lang){
                           inc_name = d.name;
                        }
                    });
                }


                let inc_start_time_utc: string;
                if(a.start_time != null){
                    inc_start_time_utc = this.createDateAsUTC(new Date(a.start_time.replace(' ', 'T').slice(0, 19)));
                }
                let inc_obj_speed = a.obj_speed;
                let inc_obj_length = a.obj_length;
                let inc_obj_lane: string;
                if(a.lane != -1){
                    inc_obj_lane = a.lane;
                }else{
                    inc_obj_lane = this.incidents_not_specified_lang;
                }
                let inc_class = '';
                let inc_cat_class = '';

                if(id == 0){

                    // ставим цвет события и у последнего по времени события маркер с колоколом
                    if(inc_level =='0' && Boolean(this.incidents_info_lang)){
                        inc_type_name = this.incidents_info_lang[this.Globals.lang];
                        inc_class = "inc-info";
                        if(i == 0){
                            inc_class = "inc-info new_inc";
                        }
                        inc_cat_class = 'inc-l-blue';
                    }
                    if(inc_level =='1' && Boolean(this.incidents_warning_lang)){
                        inc_type_name = this.incidents_warning_lang[this.Globals.lang];
                        inc_class = "inc-warning";
                        if(i == 0){
                            inc_class = "inc-warning new_inc";
                        }
                        inc_cat_class = 'inc-orange';
                    }
                    if(inc_level =='2' && Boolean(this.incidents_critical_lang)){
                        inc_type_name = this.incidents_critical_lang[this.Globals.lang];
                        inc_class = "inc-critical";
                        if(i == 0){
                            inc_class = "inc-critical new_inc";
                        }
                        inc_cat_class = 'inc-red';
                    }
                }else{
                    //ставим маркер с колоколом на событие, на которое делается переход из списка в мультифильтре
                    if(inc_level =='0' && Boolean(this.incidents_info_lang)){
                        inc_type_name = this.incidents_info_lang[this.Globals.lang];
                        inc_class = "inc-info";
                        if(id == this.inc_project[i].events_id){
                            inc_class = "inc-info new_inc";
                        }
                        inc_cat_class = 'inc-l-blue';
                    }
                    if(inc_level =='1' && Boolean(this.incidents_warning_lang)){
                        inc_type_name = this.incidents_warning_lang[this.Globals.lang];
                        inc_class = "inc-warning";
                        if(id == this.inc_project[i].events_id){
                            inc_class = "inc-warning new_inc";
                        }
                        inc_cat_class = 'inc-orange';
                    }
                    if(inc_level =='2' && Boolean(this.incidents_critical_lang)){
                        inc_type_name = this.incidents_critical_lang[this.Globals.lang];
                        inc_class = "inc-critical";
                        if(id == this.inc_project[i].events_id){
                            inc_class = "inc-critical new_inc";
                        }
                        inc_cat_class = 'inc-red';
                    }
                }
                // делаем список событий для филтра
                a["inc_name"] = inc_name;
                a["inc_class"] = inc_cat_class;
                this.eventsFilterList.push(a);

                let incTestIcon =  L.divIcon({
                   className: inc_class,
                   iconAnchor: [6,12],
                   iconSize: [12,12]
                });
                let marker:any;
                if(Boolean(a.inc_lat) && Boolean(a.inc_long)){
                    marker = L.marker(new L.LatLng(a.inc_lat, a.inc_long), {icon: incTestIcon, alt: new Date(a.start_time.replace(' ', 'T').slice(0, 19)) });

                //ставим прочерк, если длина null
                let inc_length:string;
                if(Boolean(inc_obj_length)){
                    inc_length =  inc_obj_length + ' ' + this.incidents_m_lang
                }else{
                    inc_length = ' — ';
                }


                //новый попап для маркера события
                const eventPopup = R.responsivePopup({ hasTip: true, autoPan: false, offset: [10, 20]}).setContent(
                    '<div class="cl-popup-top"><div class="cl-popup-top-right">' + inc_start_time_utc + '</div></div><div class="cl-popup-ev"><span class="inc-circle-popup ' + inc_cat_class + '"></span><span class="inc_cat_text ' + inc_cat_class + '">' + inc_type_name + '</span></div><div class="cl-popup-ev">'+ inc_name +'</div><div class="inc-popup-data">' + this.incidents_speed_lang + ': ' + inc_obj_speed + ' ' + this.incidents_kmh_lang + '</div><div class="inc-popup-data">' + this.incidents_length_lang + ': ' +inc_length + '</div><div class="inc-popup-data">' + this.incidents_lane_lang + ': ' + inc_obj_lane + '</div><div class="cl-popup-data">' + this.sensor_name_lang + ': ' + '«' + sensor_name + '»</div></div>'
                    );


                marker.bindPopup(eventPopup);

                marker.on('mouseover', function () {this.openPopup();});
                marker.on('mouseout', function () {this.closePopup();});
                marker.on('click', function (e: { latlng: any; }) {
                    //console.log('run marker onclick');
                    $this.map.setView(e.latlng, $this.currentZoom + 4);
                });
                incs_test.addLayer(marker);

                //this.incs_layer.push(marker);

                }
                this.isDataAvailable = true;
            }

            //if(id == 0){
                //преобразуем дату в списке событий
                this.eventsFilterList.forEach(ev=>{
                    ev.start_time_new = $this.createDateAsUTC(new Date(ev.start_time.replace(' ', 'T').slice(0, 19)));
                });
            //}
            if(this.set_scale){
                this.setScale();
            }
        }

        this.incs_test_clust.addLayer(incs_test);

        // в случае если переходим к последнему событию после
        if(this.wait_reset_inc){
            this.goToWaitEvent();
        }

        if (this.currentZoom > 13 && Boolean(this.incs) && this.incs.length > 0) {
            this.map.addLayer(this.incs_test_clust);
            this.filter_both_show_inc = true;
         }//else{
        //     this.incs_test_clust.clearLayers();
        //     this.map.removeLayer(this.incs_test_clust);
        // }

    }

    createAndBindPopUp(cluster: any, popHtml: string) {
      let event_name: string;
      setTimeout(() => {
        if (this.inc_last_data) {
          JSON.parse(this.inc_last_data.description).map( e => {
            if (e.lang === this.Globals.lang ) {
              event_name = e.name;
            }
          });
        }

        this.filter_both_show_inc = true;
        let color: any;
        if (this.inc_last_data) {
          switch (parseInt(this.inc_last_data.level)) {
            case 0 :
              color = '#6aa6ec';
              break;
            case 1:
              color ='#ee8703';
              break;
            case 2 :
              color ='#e33052';
          }
        }

        let inc_name = `<div style="padding-left: 20px;">
                        <div style="font-size: 14px;font-weight: 400;letter-spacing: -.34px;color: #ffc669; border-radius: 50%">
                        <div style="margin-top: -2px; float: left; height: 30px; width: 20px; display: flex; flex-direction: column;">
                        <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" width="20" height="25" viewBox="-5 -5 29 32" id="037_filter-events-list" y="1308"><path data-name="bell ring notification alarm" d="M18 16.87a1.47 1.47 0 01-1.5-1.47V8.8a7.33 7.33 0 00-6.6-7.3V0H8.43v1.5a7.34 7.34 0 00-6.6 7.3v6.6a1.46 1.46 0 01-1.46 1.47H0v1.46h7.1a2.2 2.2 0 104.13 0h7.1v-1.46zM3.3 15.4V8.8a5.87 5.87 0 1111.7 0v6.6a3 3 0 00.41 1.47H2.89a2.84 2.84 0 00.41-1.47zm6.6 3.67a.74.74 0 11-.73-.74.73.73 0 01.73.74z" stroke="#ffc669" fill="#4a4a4a"/></svg>
                        </div>
                         <span style="padding-left: 10px">${this.new_event}</span><br>
                         <span style="padding-left: 10px">${this.inc_last_data?.start_time_new}</span>
                        </div>
                        <div class="inc_name" style="font-size: 20px; font-weight: 300; margin-bottom: 10px">
                         <div style="background: ${color};border-radius: 50%;  float: left; height: 13px; width: 13px; display: flex; flex-direction: column; margin-top: 5px"></div>
                         <div style="padding-left: 30px">${event_name}</div>
                         </div>
                        </div>`;
        const inc_items = `<ul style="list-style: none; color: #919191; font-weight: 300; letter-spacing: -0.3px;font-size: 16px; padding-left: 50px; margin-bottom: 20px">
                           <li> ${this.incidents_speed_lang}: ${this.inc_last_data?.obj_speed} ${this.incidents_kmh_lang}</li>
                           <li> ${this.incidents_length_lang}: ${this.inc_last_data?.obj_length} ${this.incidents_m_lang}</li>
                           <li> ${this.incidents_lane_lang}: ${this.inc_last_data?.lane}</li>
                           <li> ${this.sensor_name_lang}: «${this.inc_last_data?.sensor_name}»</li>
                           </ul>`;
        inc_name += inc_items;
        popHtml += inc_name;
        const clusterPopup = R.responsivePopup({ hasTip: true, autoPan: false, offset: [10, 20]}).setContent(
          popHtml
        );
        this.last_event_loading = false;
        cluster.bindPopup(clusterPopup);
      }, 2000);
    }

    loadInc(){

        this.incs = [];
        this.inc_project = [];
        let send_project_id: string;
        if(Boolean(this.Globals.select_project)){
            send_project_id = this.Globals.select_project;
        }

        let params: HttpParams= new HttpParams();
        params = params.set('projects_id', send_project_id);
        if(this.eventsByFilter){
            //console.log('this.eventsByFilter)', this.eventsByFilter);
            if(this.from_filter){
                if (this.numberEvents != null && this.numberEvents != '') {
                    params = params.set('numberEvents', this.numberEvents);
                }
                if ((this.filteredTypesCheck.length > 0)) {
                    params = params.set('filteredTypesCheck', this.filteredTypesCheck.toString());
                }
                let inc_date_after = new Date(this.analisisService.dateAfter);
                if(Boolean(this.analisisService.dateBefore)){
                    let inc_date_before = new Date(this.analisisService.dateBefore);
                    if(this.from_filter && inc_date_before.getTime()> 0 && inc_date_after.getTime()> 0){
                        this.inc_begin_date = this.convertDateToUTCmac(inc_date_before);
                        this.inc_end_date = this.convertDateToUTCmac(inc_date_after);
                        params = params
                            .set('begindate', this.convertDateToUTCmac(inc_date_before).toLocaleString("ru-RU"))
                            .set('enddate', this.convertDateToUTCmac(inc_date_after).toLocaleString("ru-RU"));
                    }
                }
            }
            //отправляем в параметр список выбранных в фильтре датчиков, если галка "C учетом фильтра" отмечена

            params.set('sensors', this.sensor_select.toString());
        }
        //this.isDataAvailable = false;
        this.http_incs = this.http.get('/api/incidents/inc_data', { params }).subscribe((res:HttpResponse<any>) => {

            this.incs = res.body;
            // if(!this.incs.length){
            //     //this.isDataAvailable = true;
            //     //return 'no events'
            // }
            if((!this.eventsByFilter && this.incs.length == 0) || (this.fromfilter && this.incs.length == 0)){
                this.filter_both_show_inc = false;
                this.mf_events = false;
                this.mfChange('filter_sensors');
                this.toggleFilter(true);
                //this.isDataAvailable = true;

            }
            else{
                this.filter_both_show_inc = true;
                if(!this.mf_filter_events && !this.mf_filter_sensors){
                    this.mf_events = true;
                    this.toggleFilter(true);
                }
            }
            //временно, пока не сделано в базе, добаляем испанский и копируем в него английское значение

            for (var inc = 0; inc < this.incs.length; inc++) {
                this.incs[inc].description = JSON.parse(this.incs[inc].description);
                if(!Boolean(this.incs[inc].description[2]) && Boolean(this.incs[inc].description[1])){
                    this.incs[inc].description[2] = {"lang":"es","name":  this.incs[inc].description[1].name};
                }
                if(!Boolean(this.incs[inc].description[1])&&!Boolean(this.incs[inc].description[2]) && Boolean(this.incs[inc].description[0])){
                    this.incs[inc].description[1] = {"lang":"en","name":  this.incs[inc].description[0].name};
                    this.incs[inc].description[2] = {"lang":"es","name":  this.incs[inc].description[0].name};
                }
                if(!Boolean(this.incs[inc].description) || !this.incs[inc].description.length){
                    this.incs[inc].description[0] = {"lang":"ru","name":  "не указано"};
                    this.incs[inc].description[1] = {"lang":"en","name": "not defined"};
                    this.incs[inc].description[2] = {"lang":"es","name": "no definido"};
                }
                //округляем скорость
                this.incs[inc].obj_speed = Math.round(this.incs[inc].obj_speed * 100) / 100;
            }

            this.type_loading = false;
            this.filteredTypes = this.Globals.catList;
            this.eventsShow ? this.filterIncDisabled = false : this.filterIncDisabled = true;
            if(!this.from_filter && (this.reload_checked || this.reset_action)){
                this.filteredTypes.map(ft => {
                    ft.checked = true;
                });
                this.reload_checked = false;
                this.reset_action = false;
            }
            if(this.sensorProjectList.length > 0){
               this.drawPoints(false);
            }
            if (!this.fromfilter && this.eventsByFilter && this.incs.length == 0){
                let dialogRef = this.dialog.open(CreateDialogComponent, < MatDialogConfig > {
                    data: {
                        action: "",
                        text: this.no_events_lang,
                        icon_class:"dialog-icon-warning"
                    }
                });
                dialogRef.afterClosed().subscribe(() => {
                    this.mfChange('filter_events');
                    this.resetIncFilter(false);
                });
                return false;
            }
            this.resizingMarkersByZoom();
            //this.isDataAvailable = true;

        });
    }
    // перезагрузка инцидентов при срабатывании фильтра
    reloadInc(){
        //this.filterIncDisabled = true;
        if(Boolean(this.incs) && this.incs.length > 0){
            this.incs = [];
        //     this.incs_test_clust.clearLayers();
        //     this.map.removeLayer(this.incs_test_clust);
            this.http_incs.unsubscribe();
        }
        this.isDataAvailable = false;
        this.loadInc();
    }
    changeProj(){
        if(Boolean(this.Globals.select_project)){
            if(this.Globals.reload_project){
                this.isDataAvailable = false;
                this.analisisService.cleanSensorLists();
                this.sensorsService.clearSensorsGlobalData();
                this.ifRecieveUser();
                this.Globals.reload_project = false;
            }
            this.from_disabled_show_inc = true;
            this.mf_events = false;
            this.mf_filter_events = false;
            this.mf_filter_sensors = false;
            this.filter_both_show = false;
            this.filter_both_show_inc = false;
            this.eventsFilterList = [];
            this.dark_map = false;
            this.show_last_event = false;
            this.inc_last = [];
            this.show_last_event = false;
            this.reload_checked = true;
            this.from_filter = false;
            this.set_scale = false;

            this.sensor_select = null;
            this.show_found = true;
            this.status_select = [];
            this.statusList.map(sl=>{
                this.status_select.push(sl.code);
            });
            this.dir_select = [];
            this.dirList.map(dl=>{
                this.dir_select.push(dl.code);
            });
            if(Boolean(this.Globals.user) && this.Globals.user.role.privileges.some((e: { privileges_id: string; }) => e.privileges_id === '69770f3c-3047-f1e7-3f65-87f4792fc013')){
                this.resetIncFilter(false);
        }
    }}

    pad2(number: number) {
         return (number < 10 ? '0' : '') + number;
    }
    convertDateToUTC(date:Date) {
        return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds()).toLocaleString();
    }
    convertDateToUTCmac(date:Date) {
        return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    }
    createDateAsUTC(date:Date) {
        return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds())).toLocaleString("ru-RU");
    }
    //скрываем инциденты и дизаблим фильтр
    filterDisabled(){
        // this.eventsShow ? this.map.addLayer(this.incs_test_clust) : this.incs_test_clust.clearLayers();
        this.eventsShow ? this.drawPoints(false) : this.incs_test_clust.clearLayers();
        this.eventsShow ? this.inc_num_sel_show = true : this.inc_num_sel_show = false;
        this.eventsShow ? this.filterIncDisabled = false : this.filterIncDisabled = true;
        this.eventsShow ? this.show_last_event = true : this.show_last_event = false;
        //this.eventsShow ? this.from_disabled_show_inc = true : this.from_disabled_show_inc = false;
        if(this.last_show){
            this.eventsShow ? this.last_show = true : this.last_show = false;
        }
    }

    onLangChanged(){
        this.location_lang = '';
        this.serial_number_translated = '';
        this.current_status_lang = '';
        this.coordinates_lang = '';
        this.activation_lang  = '';
        this.statusList = [
            {"code":1,"name":'', 'class': 'st-green'}, // рабттающий зеленый
            {"code":0,"name":'', 'class': 'st-red'}, // нерабттающий красный
            {"code":2,"name":'', 'class': 'st-yellow'}, // с ошибками желтый
            {"code":4,"name":'', 'class': 'st-blue'}, // в настройке голубой
            {"code":3,"name":'', 'class': 'st-grey'}, // sensors_projects.deleted_at удаленный из проекта серый
        ];
        this.defaultFilter();
        forkJoin([
            this.translate.get('location'), //0
            this.translate.get('coordinates'), //1
            this.translate.get('activation_date'), //2
            this.translate.get('no_access'), //3
            this.translate.get('no_project'), //4
            this.translate.get('error_data'), //5
            this.translate.get('no_sensors'), //6
            this.translate.get('sensor_name'),//7
            this.translate.get('period'),//8
            this.translate.get('incidents_count'),//9
            this.translate.get('length'),//10
            this.translate.get('speed'),//11
            this.translate.get('lane'),//12
            this.translate.get('not_specified'),//13
            this.translate.get('kmH'),//14
            this.translate.get('m'),//15
            this.translate.get('dayLabels'),//16
            this.translate.get('monthLabels'),//17
            this.translate.get('select_begin'),//18
            this.translate.get('select_end'),//19
            this.translate.get('check_event_types'),//20
            this.translate.get('no_events'),//21
            this.translate.get('add_sensors_to_project'),//22
            this.translate.get('working_sensor'),//23
            this.translate.get('idle_sensor'),//24
            this.translate.get('error_sensor'),//25
            this.translate.get('deleted_sensor'),//26
            this.translate.get('from_km'),//27
            this.translate.get('to_km'),//28
            this.translate.get('current_status'),//29
            this.translate.get('zoom_in'),//30
            this.translate.get('zoom_out'),//31
            this.translate.get('sensor_in_service'),//32
            this.translate.get('sensor_serial'),//33
            this.translate.get('new_event'),//34
            this.translate.get('sensor_ip'),//35
            this.translate.get('sensor_id'),//36
            this.translate.get('coordinates_copied_to_clipboard'),//37
            this.translate.get('create_sensor'),//38
        ]).subscribe((res) =>{
            this.location_lang = res[0];
            this.coordinates_lang = res[1];
            this.activation_lang = res[2];
            this.no_permission.text = res[3];
            this.no_project.text = res[4];
            this.error_data = res[5];
            this.no_sensors_lang = res[6];
            this.sensor_name_lang = res[7];
            this.period_lang = res[8];
            this.incidents_lang = res[9];
            this.incidents_length_lang = res[10];
            this.incidents_speed_lang = res[11];
            this.incidents_lane_lang = res[12];
            this.incidents_not_specified_lang = res[13];
            this.incidents_kmh_lang = res[14];
            this.incidents_m_lang = res[15];
            this.dayLabels = res[16];
            this.monthLabels = res[17];
            this.begin_lang = res[18];
            this.end_lang = res[19];
            this.check_event_types_lang = res[20];
            this.no_events_lang = res[21];
            this.add_sensors_to_project = res[22];

            //создаем список статусов и отмечаем все по умолчанию
            this.statusList = [
                {"code":1,"name":res[23], 'class': 'st-green'}, // рабттающий зеленый
                {"code":0,"name":res[24], 'class': 'st-red'}, // нерабттающий красный
                {"code":2,"name":res[25], 'class': 'st-yellow'}, // с ошибками желтый
                {"code":4,"name":res[32], 'class': 'st-blue'}, // в настройке голубой
                {"code":3,"name":res[26], 'class': 'st-grey'}, // sensors_projects.deleted_at удаленный из проекта серый
            ];
            this.status_select = [];
            this.statusList.forEach(st=>{
                this.status_select.push(st.code);
            });
            //создаем список направлений и отмечаем все по умолчанию
            this.dirList = [
                {"code":1,"name":res[27]},
                {"code":0,"name":res[28]}
            ];
            this.dir_select = [];
            this.dirList.forEach(d=>{
                this.dir_select.push(d.code);
            });
            this.current_status_lang = res[29];
            this.zoom_in_lang = res[30];
            this.zoom_out_lang = res[31];
            this.serial_number_translated = res[33];
            this.new_event = res[34];
            this.sensor_ip_translated = res[35];
            this.sensor_id_translated = res[36];
            this.coordinates_copied_to_clipboard_lang = res[37];
            this.create_sensor_lang = res[38];
            this.right_click_popup.remove();
            this.loadMap();
        });

        //нужно поменять список статусов при переключении языка
        //console.log('this.changed_sensors',this.changed_sensors);
        if(this.changed_sensors.length){
            this.changed_sensors.forEach(ch_s=>{
                ch_s.status_v_list = this.sensorsService.translateStatus(ch_s.status_v_list_codes);
            });
        }
        if(this.sensorProjectList.length){
            this.sensorProjectList.forEach(ch_s=>{
                ch_s.status_v_list = this.sensorsService.translateStatus(ch_s.status_v_list_codes);
            });
            if(Boolean(this.map)){
                //если применен фильтр статусов
                if(this.status_select.length < 4 && this.fromfilter){
                    this.chooseDirStatus(true);
                    if(this.sensor_select.length == 0){
                    this.defaultFilter();
                    }
                }else{
                    this.markersIcons();
                }
            }
        }

    }
    resizingMarkersByZoom(){
        let $this = this;
        this.map.on('zoomend', function(e: { target: { getZoom: () => number; }; }) {

            $this.currentZoom = e.target.getZoom();
            //console.log('zoom', $this.currentZoom);
            if($this.fitZoom != 0 && $this.currentZoom != $this.fitZoom){
                $this.touch_map = true;
            }

            //incendents test
            if(Boolean($this.markersList)){
                if ($this.currentZoom > 13 && Boolean($this.incs) && $this.incs.length > 0 && $this.eventsShow) {
                    if(Boolean($this.incs_test_clust)){
                        $this.map.addLayer($this.incs_test_clust);
                    }
                }
                if ($this.currentZoom < 14) {
                    if(Boolean($this.incs_test_clust)){
                        $this.map.removeLayer($this.incs_test_clust);
                    }
                    //$this.incs_test_clust.clearLayers();
                }
                if ($this.currentZoom > 16) {
                    //large icons
                    $this.markersList.eachLayer((layer: { options: { icon: { options: { className: any; }; }; }; setIcon: (arg0: any) => any; }) => {
                        let classValue = layer.options.icon.options.className;
                        if( classValue == 'marker-error marker-small'){
                            return layer.setIcon($this.idleIcon);
                        }
                        if( classValue == 'marker-error marker-small marker-dir'){
                            return layer.setIcon($this.idleIconDir);
                        }
                        if( classValue == 'marker-inactive marker-small'){
                            return layer.setIcon($this.inactiveIcon);
                        }
                        if( classValue == 'marker-inactive marker-small marker-dir'){
                            return layer.setIcon($this.inactiveIconDir);
                        }
                        if(classValue == 'marker-active marker-small'){
                            return layer.setIcon($this.activeIcon);
                        }
                        if(classValue == 'marker-active marker-small marker-dir'){
                            return layer.setIcon($this.activeIconDir);
                        }
                        if(classValue == 'marker-selected-error marker-small'){
                            return layer.setIcon($this.selectedIconIdle);
                        }
                        if(classValue == 'marker-selected-error marker-small marker-dir'){
                            return layer.setIcon($this.selectedIconIdleDir);
                        }
                        if(classValue == 'marker-selected-inactive marker-small'){
                            return layer.setIcon($this.selectedIconInactive);
                        }
                        if(classValue == 'marker-selected-inactive marker-small marker-dir'){
                            return layer.setIcon($this.selectedIconInactiveDir);
                        }
                        if(classValue == 'marker-selected-active marker-small') {
                            return layer.setIcon($this.selectedIconActive);
                        }
                        if(classValue == 'marker-selected-active marker-small marker-dir') {
                            return layer.setIcon($this.selectedIconActiveDir);
                        }
                        if(classValue == 'marker-deleted marker-small') {
                            return layer.setIcon($this.deletedIcon);
                        }
                      if(classValue == 'marker-in-service marker-small') {
                        return layer.setIcon($this.inServiceIcon);
                      }
                        if(classValue == 'marker-selected-deleted marker-small') {
                            return layer.setIcon($this.selectedIconDeleted);
                        }
                      if(classValue == 'marker-selected-in-service marker-small') {
                        return layer.setIcon($this.selectedIconInService);
                      }
                        if(classValue == 'marker-deleted marker-small marker-dir') {
                            return layer.setIcon($this.deletedIconDir);
                        }
                      if(classValue == 'marker-in-service marker-small marker-dir') {
                        return layer.setIcon($this.inServiceIconDir);
                      }
                        if(classValue == 'marker-selected-deleted marker-small marker-dir') {
                            return layer.setIcon($this.selectedIconDeletedDir);
                        }
                      if(classValue == 'marker-selected-in-service marker-small marker-dir') {
                        return layer.setIcon($this.selectedIconInServiceDir);
                      }
                    });
                }else {
                    //small icons
                    $this.markersList.eachLayer((layer: { options: { icon: { options: { className: any; }; }; }; setIcon: (arg0: any) => any; }) => {
                        let classValue = layer.options.icon.options.className;
                        if(classValue == 'marker-error'){
                            return layer.setIcon($this.idleIconSmall);
                        }
                        if(classValue == 'marker-error marker-dir'){
                            return layer.setIcon($this.idleIconSmallDir);
                        }
                        if(classValue == 'marker-inactive'){
                            return layer.setIcon($this.inactiveIconSmall);
                        }
                        if(classValue == 'marker-inactive marker-dir'){
                            return layer.setIcon($this.inactiveIconSmallDir);
                        }
                        if(classValue == 'marker-active'){
                            return layer.setIcon($this.activeIconSmall);
                        }
                        if(classValue == 'marker-active marker-dir'){
                            return layer.setIcon($this.activeIconSmallDir);
                        }
                        if(classValue == 'marker-selected-error'){
                            return layer.setIcon($this.selectedIconIdleSmall);
                        }
                        if(classValue == 'marker-selected-error marker-dir'){
                            return layer.setIcon($this.selectedIconIdleSmallDir);
                        }
                        if(classValue == 'marker-selected-inactive'){
                            return layer.setIcon($this.selectedIconInactiveSmall);
                        }
                        if(classValue == 'marker-selected-inactive marker-dir'){
                            return layer.setIcon($this.selectedIconInactiveSmallDir);
                        }
                        if(classValue == 'marker-selected-active'){
                            return layer.setIcon($this.selectedIconActiveSmall);
                        }
                        if(classValue == 'marker-selected-active marker-dir'){
                            return layer.setIcon($this.selectedIconActiveSmallDir);
                        }
                        if(classValue == 'marker-deleted') {
                            return layer.setIcon($this.deletedIconSmall);
                        }
                        if(classValue == 'marker-in-service') {
                          return layer.setIcon($this.inServiceIconSmall);
                        }
                        if(classValue == 'marker-selected-deleted') {
                            return layer.setIcon($this.selectedIconDeletedSmall);
                        }
                        if(classValue == 'marker-selected-in-service') {
                          return layer.setIcon($this.selectedIconInServiceSmall);
                        }
                        if(classValue == 'marker-deleted marker-dir') {
                            return layer.setIcon($this.deletedIconSmallDir);
                        }
                        if(classValue == 'marker-in-service marker-dir') {
                          return layer.setIcon($this.inServiceIconSmallDir);
                        }
                        if(classValue == 'marker-selected-deleted marker-dir') {
                            return layer.setIcon($this.selectedIconDeletedSmallDir);
                        }
                        if(classValue == 'marker-selected-in-service marker-dir') {
                          return layer.setIcon($this.selectedIconInServiceSmallDir);
                        }
                    });
                }
            }//else{
            //     $this.isDataAvailable = false;
            //     $this.printInc(0);
            // }
            //incendents test
        });
    }
    applyFilterNew(){
        this.fromfilter = true;
        this.last_show = false;
        this.ev_list_id = '';
        this.eventsByFilter = true;

        //меняем список fit (масштабирование карты)  в зависимости от выбранных в селекте датчиков
        this.fit = [];
        this.sensorProjectList.map((sensor) => {
            if(this.sensor_select.indexOf(sensor.sensor_id)!= -1){
                this.fit.push([sensor.configuration.gps_latitude, sensor.configuration.gps_longitude]);
            }
        });
        if(this.fit.length > 0){
            this.map.fitBounds(this.fit,{maxZoom: 18, paddingBottomRight: [200,0]});
            this.currentZoom = this.map.getZoom();
            this.touch_map = false;
            this.reloadInc();
        }
    }
    defaultFilter() {
        this.fromfilter = false;
        this.eventsByFilter = false;
        this.ev_list_id = '';
        this.analisisService.changeSensorsData([]);
        this.ifRecieveUser();
        this.sensor_select = null;
        this.show_found = true;
        this.status_select = [];
        this.statusList.map(sl=>{
            this.status_select.push(sl.code);
        });
        this.dir_select = [];
        this.dirList.map(dl=>{
            this.dir_select.push(dl.code);
        });

        this.chooseDirStatus(false);
        this.applyFilterNew();
    }

    selectAll(un: string = '') {

        let selected_sensors_temp = [];
        if(this.sensor.length > 0){
            if(un == 'un'){
                this.sensor.forEach(s=>{
                    s.selected = false;
                });
                this.analisisService.changeData([]);
            }else{
                this.sensor.forEach(s=>{
                    s.selected = true;
                    selected_sensors_temp.push(s);
                });
                this.analisisService.changeData(selected_sensors_temp);

            }
            if(this.sensorProjectList.length > 0 && Boolean(this.map)){
                if(this.markersList.length){
                    // this.markersList.eachLayer((marker: { clearLayers: () => void; }) => {
                    //     //this.map.removeLayer(marker);
                    //     marker.clearLayers();
                    //     //this.map.remove(marker);
                    // });
                    this.markersList.clearLayers();
                }
               this.drawPoints(false);
            }
        }
    }



    openhelp(){
        let dialogRef = this.dialog.open(HelpDialogComponent, <MatDialogConfig>{
        });
        dialogRef.afterClosed().subscribe(() => {
            document.body.style.overflow='auto';
        });
    }
    /**
       Returns the bearing in degrees clockwise from north (0 degrees)
       from the first L.LatLng to the second, at the first LatLng
       @param {L.LatLng} latlng1: origin point of the bearing
       @param {L.LatLng} latlng2: destination point of the bearing
       @returns {float} degrees clockwise from north.
    */
    bearing(latlng1: { lat: number; lng: number; }, latlng2: { lat: number; lng: number; }) {
        let rad = Math.PI / 180,
            lat1 = latlng1.lat * rad,
            lat2 = latlng2.lat * rad,
            lon1 = latlng1.lng * rad,
            lon2 = latlng2.lng * rad,
            y = Math.sin(lon2 - lon1) * Math.cos(lat2),
            x = Math.cos(lat1) * Math.sin(lat2) -
                Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1);
        let bearing = ((Math.atan2(y, x) * 180 / Math.PI) + 360) % 360;
        return bearing >= 180 ? bearing-360 : bearing;
    }
    /**
     Returns the point that is a distance and heading away from
     the given origin point.
     @param {L.LatLng} latlng: origin point
     @param heading
     @param distance
     @returns {L.latLng} the destination point.
     Many thanks to Chris Veness at http://www.movable-type.co.uk/scripts/latlong.html
     for a great reference and examples.
     */
    destination(latlng: { lng: number; lat: number; }, heading: number, distance: number) {
        heading = (heading + 360) % 360;
        let rad = Math.PI / 180,
            radInv = 180 / Math.PI,
            R = 6378137, // approximation of Earth's radius
            lon1 = latlng.lng * rad,
            lat1 = latlng.lat * rad,
            rheading = heading * rad,
            sinLat1 = Math.sin(lat1),
            cosLat1 = Math.cos(lat1),
            cosDistR = Math.cos(distance / R),
            sinDistR = Math.sin(distance / R),
            lat2 = Math.asin(sinLat1 * cosDistR + cosLat1 *
                sinDistR * Math.cos(rheading)),
            lon2 = lon1 + Math.atan2(Math.sin(rheading) * sinDistR *
                cosLat1, cosDistR - sinLat1 * Math.sin(lat2));
        lon2 = lon2 * radInv;
        lon2 = lon2 > 180 ? lon2 - 360 : lon2 < -180 ? lon2 + 360 : lon2;
        return L.latLng(lat2 * radInv, lon2);
    }
    lastShow(){
        this.last_event_loading = true;
        this.last_show = !this.last_show;
        if(this.last_show){
            setTimeout(()=>{
                this.last_event_loading = false;
            },300);
        }
        this.filters_show = true;
    }
    toggleFilter(show: boolean){

        this.mf_max_show = false;
        this.filters_show = !this.filters_show;
        if(show){
           this.filters_show = true;
        }
        if(this.filters_show){
            this.filter_closed = false;
            this.mf_max_loading = true;
            setTimeout(()=>{
                this.mf_max_loading = false;
                this.mf_max_show = true;
                this.moveMapControls(true);
            },300);
        }else{
            this.mf_max_show = false;
            this.last_show  = false;
            this.filter_closed = true;
            this.moveMapControls(false);
        }

    }

    //***функции мультифильтра
    eventsByFilterSwitch(){
        this.reloadInc();
    }
    mfChange(tab: string){
        switch(tab){
            case 'events':
                this.mf_events = true;
                this.mf_filter_events = false;
                this.mf_filter_sensors = false;
                // if(!this.eventsShow){
                //    this.eventsShow = true;
                //    this.from_disabled_show_inc = true;
                // }
            break;
            case 'filter_events':
                this.mf_events = false;
                this.mf_filter_events = true;
                this.mf_filter_sensors = false;
            break;
            case 'filter_sensors':
                this.mf_events = false;
                this.mf_filter_events = false;
                this.mf_filter_sensors = true;
            break;
        }
    }
    //функции мультифильтра***

    defaultScale(){
        if(this.fit.length > 0){
            this.map.fitBounds(this.fit,{maxZoom: 18, paddingBottomRight: [200,0]});
            this.currentZoom = this.map.getZoom();
            this.touch_map = false;
        }
    }

    /**
     * Call selectService toggleSelectAll function
     * @param sensorProjectList
     * @param getSensor
     * @param bindValue
     * @param ng_model
     */
    toggleSelectAll(sensorProjectList: any[], getSensor: NgModel, bindValue: string, ng_model: any) {
      this.selectService.toggleSelectAll(sensorProjectList, getSensor, bindValue,  ng_model);
    }


   /**
   * Changing the position of the icon and popup depending on the zoom
   * @param zoom true | false
   */
   setStyleDependingZoom(zoom: boolean) {
       if (zoom) {
         this.warAnchor = [[16, 20], [-27, 20], [-5, 49]];
         this.warType = ['info', 'war', 'critical'];
       } else {
         this.warAnchor = [[16, 20], [-17, 20], [0, 39]];
         this.warType = ['info-z', 'war-z', 'critical-z'];
       }
    }

  /**
   * Add sensor error icons.
   * @param sensor
   */
  addSensorWarnings(sensor: any) {
    let that = this;
    let errors: any = { 'info':[], 'war':[],'critical': [], };

    // Sets icon and popup class by default
    this.setStyleDependingZoom(this.currentZoom >= 17);

    // Sets icon and popup class after Zooming
    this.map.on('zoomend',function() {
      that.setStyleDependingZoom(this.getZoom() >= 17);
    });

    sensor.warnings.map(w => {
      if (w.level == 0) {
        errors['info'].push(JSON.parse(w.code_name)[this.Globals.lang]);
        this.createErrorIconsAddPopUp(0 ,sensor, errors, this.senErrIcons[0], 0, this.generatePopupText(errors['info'],[-20,30], sensor ));
      }
      if (w.level == 1) {
        errors['war'].push(JSON.parse(w.code_name)[this.Globals.lang]);
        this.createErrorIconsAddPopUp(1 ,sensor, errors, this.senErrIcons[1], 1 , this.generatePopupText(errors['war'], [20, 30], sensor));
      }
      if (w.level == 2) {
        errors['critical'].push(JSON.parse(w.code_name)[this.Globals.lang]);
        this.createErrorIconsAddPopUp(2 , sensor, errors, this.senErrIcons[2], 2 , this.generatePopupText(errors['critical'], [20, 50], sensor));
      }
    });
   }

  /**
   * Create Sensor warnings icons and add to them popup.
   * @param type
   * @param sensor
   * @param errors
   * @param image
   * @param anchor
   * @param Popup
   */
   createErrorIconsAddPopUp(type: number, sensor:any, errors: any, image:any, anchor: any, Popup: any) {
      let that = this;
    let projects_ids = [];
    const layerGroup = L.layerGroup().addTo(this.map);
    sensor.projects.map(project => {
      projects_ids.push(project.projects_id);
    })

    if (this.Globals.selectedProjectId) {
      if(projects_ids.includes(this.Globals.selectedProjectId) ) {
        this.addMarker(type, sensor, errors, image, anchor, Popup, layerGroup)
      } else {
        layerGroup.clearLayers();
      }
    } else {
      this.addMarker(type, sensor, errors, image, anchor, Popup, layerGroup);
    }


    // After zooming layerGroup clear marker, than add with new icon and popup classes.
      this.map.on('zoomend',function() {
        layerGroup.clearLayers();
        if (that.Globals.selectedProjectId) {
          if(projects_ids.includes(that.Globals.selectedProjectId) ) {
            that.addMarker(type, sensor, errors, image, anchor, Popup, layerGroup)
          } else {
            layerGroup.clearLayers();
          }
        } else {
          that.addMarker(type, sensor, errors, image, anchor, Popup, layerGroup);
        }

      })
   }

  /**
   * Add Or clear marker with popup while zooming.
   * @param type
   * @param sensor
   * @param errors
   * @param image
   * @param anchor
   * @param Popup
   * @param layerGroup
   */
   addMarker(type: number, sensor:any, errors: any, image:any, anchor: any, Popup: any, layerGroup: any) {
      let that = this;
      L.marker([sensor.configuration.gps_latitude, sensor.configuration.gps_longitude], {
         icon : L.icon({
            iconUrl: image,
            iconSize: [20, 20],
            className: 'warnings-map-icon-' +  that.warType[type],
            iconAnchor: that.warAnchor[type],
         }),
      }).addTo(layerGroup).bindPopup(Popup)
         .on('mouseover', function () {
           this.openPopup();
           Popup._container.className = `leaflet-popup leaflet-zoom-animated leaflet-resp-popup-north ${that.warType[type]}`;
           that.redirectToSensor(sensor);
         })
   }

  /**
   * Generate popup content.
   * @param errors
   * @param offset [10, 30]
   * @param sensor
   */
   generatePopupText(errors: any, offset: any, sensor: any) {
     let content = `<div style="pointer-events:initial!important;"><h4 class="warnings-headers" style="cursor: default"> ${sensor.name} </h4> <ol class="warnings-list">` + errors.map( err => { return  `<li style="color:#8d8f91;" class="sensor_error">${err}</li>` }) + `</ol></div>`;
     content = content.replace(new RegExp('>,', 'g'), '>');
     return R.responsivePopup({ hasTip: true, autoPan: false, offset: offset }).setContent(content);
   }

  redirectToSensor(sensor) {
     let that = this;
     let errors = Array.from(document.getElementsByClassName('sensor_error'));
     let headers = Array.from(document.getElementsByClassName('warnings-headers'));
     this.setStyleToHoveredErrorList(errors, sensor);
     this.setStyleToHoveredErrorList(headers, sensor);
    }
    setStyleToHoveredErrorList(element,  sensor) {
      let that = this;
      element.map(el => {
        el.addEventListener('mouseover', function () {
          this.style.cssText =`color: #f5a623!important; cursor: pointer`;
        });
        el.addEventListener('mouseout', function () {
          let own_color = el.tagName == 'LI' ? '#8d8f91' : '#fff';
          this.style.cssText =`color: ${own_color};!important; cursor:default`;
        });
        el.addEventListener('click', function () {
          that.router.navigate([`/admin/admin-sensors/${sensor.sensor_id}/general`]);
        });
      })
    }

  ngOnDestroy() {
    document.querySelector('body').classList.remove('vt-bg');
    if(Boolean(this.refresh_interval))
      clearInterval(this.refresh_interval);
    if(Boolean(this.clear_interval))
      clearInterval(this.clear_interval);
    if(Boolean(this.interval))
      clearInterval(this.interval);
    if(Boolean(this.http_user))
      this.http_user.unsubscribe();
    if(Boolean(this.http_sensors))
      this.http_sensors.unsubscribe();
    if(Boolean(this.http_sensors_check))
      this.http_sensors_check.unsubscribe();
    if(Boolean(this.changeProjCancel))
      this.changeProjCancel.unsubscribe();
    if(Boolean(this.changeLangCancel))
      this.changeLangCancel.unsubscribe();
    if(Boolean(this.http_events_check))
      this.http_events_check.unsubscribe();
    if(Boolean(this.http_incs))
      this.http_incs.unsubscribe();
    if(Boolean(this.http_sensors))
      this.http_sensors.unsubscribe();
  }
}
